const formMap = new Map([
    [
        "m_allstaff_mail",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>Allstaff全员邮件申请单</em>，请您审批。
            </p>
        </div>
    </ax-head>

<ax-panel title="Allstaff相关信息">
    <van-cell title="邮件类型" :value="data.mail_type_name"></van-cell>
    <van-cell title="邮件主题" :value="data.theme"></van-cell>
    <van-cell title="邮件上传" v-if="isJSON(data.attachment)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.attachment)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
    <van-cell>
        注：请将已发给 allstaff@360.cn/g-manager@360.cn的邮件另存为*.msg格式后上传。
    </van-cell>
    <van-cell title="是否包含外链或二维码" :value="data.external_links_name"></van-cell>
    <van-cell>
        注：若正文中涉及二维码或非360网址的链接，请选择是。
    </van-cell>
    <ax-fold>
        <van-cell class="top-item" title="发文须知：" :class="{ 'errors_box':errors.has('standard')}"></van-cell>
        <van-cell>
            <div>
                1、申请人及直接上级领导，要对本封全员邮件内容负全部责任。
            </div>
            <div>
                2、Allstaff邮件放行时间为9:30-20:00。流程完成后，两个工作小时内完成放行。
            </div>
            <div>
                3、有任何问题，请电话联系58781234或发邮件至it@360.cn说明问题。
            </div>
            <div>
                4、正文内联系邮箱只能以“360.cn”为后缀。
            </div>
            <div v-if="permission.declare_form ==='w'">
                <van-radio-group v-model="data.declare" v-validate="'required'" name="declare">
                    <van-radio v-for="(item, index) in agreeSpecialOptions" :key="index" :name="item.value">
                        {{item.label}}
                    </van-radio>
                </van-radio-group>
            </div>
            <div v-else="">
                {{data.declare_name}}
            </div>
        </van-cell>
    </ax-fold>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "m_mobile_application",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>手机邮箱申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>
<ax-panel title="相关信息">
    <van-cell title="申请原因" :value="data.reason"></van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "m_ofa_application",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的运营号申请单，请您审批。
        </p>
    </div>
</ax-head>
<ax-panel title="相关信息">
    <van-cell title="运营号名称" :value="data.ofa_name"></van-cell>
    <van-cell title="运营号介绍" :value="data.ofa_description"></van-cell>
    <van-cell title="封面图片" v-if="isJSON(data.ofa_cover)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.ofa_cover)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "m_outsourcer_account",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>外部人员账号申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>
<ax-panel title="相关信息">
    <van-cell title="接口人主管" v-model="data.inner_manager"></van-cell>
    <van-cell title="接口人HR" v-model="data.inner_hr"></van-cell>
    <van-cell title="申请类型" v-model="data.type_name"></van-cell>
    <van-cell title="是否有合同" v-model="data.has_contract_name"></van-cell>
    <van-cell title="账号类型" v-model="data.account_type_name"></van-cell>
    <van-cell title="申请原因" v-model="data.reason"></van-cell>
</ax-panel>

<ax-panel title="明细信息" v-if="data.SUB_outsourcer_account_item.length">
    <div v-for="(item, index) in data.SUB_outsourcer_account_item" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="外来员工姓名" v-model="item.outsourcer_name"></van-cell>
        <van-cell title="姓名拼音" v-model="item.outsourcer_pinyin"></van-cell>
        <van-cell title="使用期限" v-model="item.use_period"></van-cell>
        <van-cell title="合同编号" v-model="item.contract_no"></van-cell>
        <van-field v-if="permission.outsourcer_account_item_table ==='w'" label="域账号" v-model="item.outsourcer_domain" placeholder="请输入域账号" v-validate="'required'" :name="domain"+index :class="{ 'errors_box':errors.has('domain'+index)}"></van-field>
        <van-cell v-else title="域账号" v-model="item.outsourcer_domain"></van-cell>
        <van-cell  title="手机号码" v-model="item.outsourcer_phone"></van-cell>
        <van-cell title="私有云盘存储权限"  v-if="item.cloud_disk_auth_name" v-model="item.cloud_disk_auth_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "m_phone_application",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>电话机申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="相关信息">
    <van-cell title="办公地点" :value="data.office_address"></van-cell>
    <van-field v-if="permission.phone_ext_form ==='w'" label="分机号" v-model="data.phone_ext" placeholder="请输入分机号" type="number" v-validate="{ required: true, digits:4 }" name="phone" :class="{ 'errors_box':errors.has('phone')}"></van-field>
    <van-cell v-else="" title="分机号" v-model="data.phone_ext"></van-cell>
    <van-cell title="是否采购" class="radio_box" :class="{ 'errors_box':errors.has('needPurchase')}" v-if="false && permission.need_purchase_form==='w'">
        <van-radio-group v-model="data.need_purchase" v-validate="'required'" name="needPurchase">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <van-cell title="是否采购" :value="data.need_purchase_name" v-if="false"></van-cell>
    <van-cell title="申请原因" :value="data.reason"></van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "m_use_sms_platform",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>短信平台使用申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="相关信息">
    <van-cell title="业务名称" v-model="data.business_name"></van-cell>
    <van-cell title="业务负责人" v-model="data.business_owner"></van-cell>
    <van-cell title="业务组" v-model="data.business_group"></van-cell>
    <van-cell title="申请原因" v-model="data.apply_reason"></van-cell>
    <van-cell title="短信内容" v-model="data.message_content_example"></van-cell>
    <ax-fold>
        <van-cell title="月预估量" v-model="data.estimated_monthly_transmission"></van-cell>
        <van-cell title="接口人:" v-model="data.interface_person_name"></van-cell>
        <van-cell title="短信通道" v-model="data.message_channel_type"></van-cell>
        <van-cell title="默认签名" v-model="data.is_use_default_signature"></van-cell>
        <van-cell title="短信签名" v-model="data.message_signature"></van-cell>
        <van-cell title="通道组" v-model="data.sms_channel_group"></van-cell>
    </ax-fold>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "m_vpn_application",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>VPN授权申请单</em>，请您审批。
        </p>
    </div>
</ax-head>
<ax-panel title="相关信息">
    <van-cell title="申请类别" :value="data.vpn_type_name"></van-cell>
    <van-cell title="申请原因" v-if="data.reason" :value="data.reason"></van-cell>
    <div v-if="permission.remind_approver_form==='w'">
        <van-cell title="提醒事项" :class="{ 'errors_box':errors.has('standard')}">
            <div>
                1, VPN系统是为了便于用户经Internet远程访问公司内部网络而设立，但由于用户客户端计算机
的安全性不可控制，可能会影响内部网络安全，请慎重审批VPN使用权限<br/>2, 因员工泄露vpn密码与在不安全的客户端使用导致内网安全入侵，由员工本人及其审批上级
承担责任
            </div>
            <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
                <van-radio v-for="(item, index) in agreeOptions" :key="index" :name="item.value">
                    {{item.label}}
                </van-radio>
            </van-radio-group>
        </van-cell>
    </div>
    <div v-else="">
        <van-cell title="审批事项">
            <div>
            1, VPN系统是为了便于用户经Internet远程访问公司内部网络而设立，但由于用户客户端计算机
    的安全性不可控制，可能会影响内部网络安全，请慎重审批VPN使用权限<br/>2, 因员工泄露vpn密码与在不安全的客户端使用导致内网安全入侵，由员工本人及其审批上级
    承担责任
            </div>
            <div>
                {{data.remind_approver_name}}
            </div>
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "m_webex_meeting",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>Webex会议系统账号申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="相关信息">
    <van-cell title="开始时间" :value="data.start_time"></van-cell>
    <van-cell title="会议时间" :value="data.meeting_hours"></van-cell>
    <van-cell title="摄像头" :value="data.need_camera_name"></van-cell>
    <van-cell v-if="data.need_camera_name!=='否'" title="摄像头数量" :value="data.camera_count"></van-cell>
    <van-cell title="参会方数量" :value="data.participants"></van-cell>
    <van-cell title="申请原因" :value="data.cause"></van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000000740001",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>投资事项审批申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="基本信息">
    <van-cell title="投资事项单号" v-model="data.project_code"></van-cell>
    <van-cell title="投资项目名称" v-model="data.project_name"></van-cell>
    <van-cell title="我方投资主体名称" v-model="data.our_company_name"></van-cell>
    <van-cell title="标的公司名称" v-model="data.contract_object_company"></van-cell>
    <van-cell title="360持股比例" v-model="data.existing_hold_shares"></van-cell>
    <van-cell title="事项说明" v-model="data.item_description"></van-cell>
</ax-panel>
<ax-panel title="项目特殊信息">
    <div v-if="data.is_trade_relate === '1'">
        <van-cell class="top-item" title="360投资成本">
            {{data.investment_cost}} {{data.cost_currency_name}}
        </van-cell>
        <van-cell title="现有估值">
            {{data.existing_valuation}} {{data.valuation_currency_name}}
        </van-cell>
        <van-cell title="标的资产总额">
            {{data.asset_total}} {{data.total_currency_name}}
        </van-cell>
        <van-cell title="标的年营业收入" v-model="data.annual_income"></van-cell>
        <van-cell title="标的年净利润" v-model="data.annual_net_profits"></van-cell>
        <ax-fold>
            <van-cell title="是否关联交易" v-model="data.is_related_transaction_name"></van-cell>
            <van-cell title="关联方名称" v-model="data.related_name"></van-cell>
            <van-cell title="关联交易形成原因" v-model="data.related_trans_cause_name"></van-cell>
            <van-cell title="是否对控、参股公司增资" v-model="data.is_added_money_name"></van-cell>
            <van-cell title="增资金额" v-if="data.is_added_money">
                {{data.added_amount}} {{data.added_currency_name}}
            </van-cell>
            <van-cell title="是否放弃优先权益" v-model="data.is_give_up_priority_name"></van-cell>
            <van-cell title="放弃权益类别" v-model="data.give_up_priority_type_name"></van-cell>
            <van-cell title="放弃部分估值">
                {{data.give_up_valuation}}{{data.gu_valuation_currency_name}}
            </van-cell>
            <van-cell title="是否购买或出售资产/股权" v-model="data.is_buy_sell_assets_name"></van-cell>
            <van-cell title="成交金额" v-model="data.gmv">
                {{data.gmv}} {{data.gmv_currency_name}}
            </van-cell>
            <van-cell title="交易产生利润">
                {{data.transaction_profit}} {{data.profit_currenty_name}}
            </van-cell>
            <van-cell title="是否提供借款或担保" v-model="data.is_borrow_money_name"></van-cell>
            <van-cell title="涉及金额">
                {{data.involve_amount}}{{data.involve_currency_name}}
            </van-cell>
            <van-cell title="最终持股比例" v-model="data.final_hold_shares"></van-cell>
            <van-cell title="合并报表范围是否变更" v-model="data.is_merge_rep_chg_name"></van-cell>
            <van-cell title="是否涉及基金投资" v-model="data.is_fund_investment_name"></van-cell>
            <van-cell title="参与已上市公司再融资" v-model="data.is_re_financing_name"></van-cell>
            <van-cell title="是否涉及购买或出售金融资产" v-model="data.is_buy_sell_finance_assets_name"></van-cell>
            <van-cell title="是否涉及品牌等授权许可" v-model="data.is_brand_licensing_name"></van-cell>
            <van-cell title="连续12个月内对同一标的累计投资" v-model="data.continuous_investment"></van-cell>
            <van-cell title="是否需要盖公章/签字" v-model="data.is_sign_name"></van-cell>
        </ax-fold>
    </div>
    <div v-else="">
        <van-cell title="是否需要盖公章/签字" v-model="data.is_sign_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="审批回填" v-if="(permission.is_important_law_form==='w'&&bpmTask.name==='法务复审')||(permission.is_important_fin_form==='w'&&bpmTask.name==='财务复审')||(permission.is_important_securities_form==='w'&&bpmTask.name==='证券部初审') || (permission.is_important_invest_form==='w'&&bpmTask.name==='投后负责人')">
    <div v-if="permission.is_important_law_form==='w'&&bpmTask.name==='法务复审'">
        <van-cell title="是否重大（法律）" class="radio_box" :class="{ 'errors_box':errors.has('importantLaw')}">
            <van-radio-group v-model="data.is_important_law" v-validate="'required'" name="importantLaw">
                <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                    {{item.label}}
                </van-radio>
            </van-radio-group>
        </van-cell>
        <van-field label="说明" v-model="data.is_important_law_remark" placeholder="请输入说明"></van-field>
    </div>
    <div v-if="permission.is_important_fin_form==='w'&&bpmTask.name==='财务复审'">
        <van-cell title="是否重大（财务）" class="radio_box" :class="{ 'errors_box':errors.has('importantFin')}">
            <van-radio-group v-model="data.is_important_fin" v-validate="'required'" name="importantFin">
                <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                    {{item.label}}
                </van-radio>
            </van-radio-group>
        </van-cell>
        <van-field label="说明" v-model="data.is_important_fin_remark" placeholder="请输入说明"></van-field>
    </div>
    <div v-if="permission.is_important_securities_form==='w'&&bpmTask.name==='证券部初审'">
        <van-cell title="是否重大（证券）" class="radio_box" :class="{ 'errors_box':errors.has('importantSec')}">
            <van-radio-group v-model="data.is_important_securities" v-validate="'required'" name="importantSec">
                <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                    {{item.label}}
                </van-radio>
            </van-radio-group>
        </van-cell>
        <van-field label="说明" v-model="data.is_important_securities_remark" placeholder="请输入说明"></van-field>
    </div>
    <div v-if="permission.is_important_invest_form==='w'&&bpmTask.name==='投后负责人'">
        <van-cell title="是否重大" class="radio_box" :class="{ 'errors_box':errors.has('importantInv')}">
            <van-radio-group v-model="data.is_important_invest" v-validate="'required'" name="importantInv">
                <van-radio v-for="(item, index) in investOptions" :key="index" :name="item.value">
                    {{item.label}}
                </van-radio>
            </van-radio-group>
        </van-cell>
        <van-field label="说明" v-model="data.is_important_invest_remark" placeholder="请输入说明"></van-field>
    </div>
</ax-panel>

<ax-panel title="盖章附件" v-if="isJSON(data.stamp_file)">
    <ax-down class="out-down" v-for="(fileItem,index) in JSON.parse(data.stamp_file)" type="ssc" :data="fileItem" :key="index"></ax-down>
</ax-panel>
<ax-panel title="其他附件" v-if="isJSON(data.other_file)">
    <ax-down class="out-down" v-for="(fileItem,index) in JSON.parse(data.other_file)" type="ssc" :data="fileItem" :key="index"></ax-down>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel> `
    ],
    [
        "MFM_1100000011930064",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>内部宣传资源申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="申请信息">
    <van-cell title="宣传名称" v-model="data.name"></van-cell>
    <van-cell title="宣传目的" v-model="data.purpose"></van-cell>
    <van-cell title="宣传渠道" v-model="data.channel_name"></van-cell>
</ax-panel>
<ax-panel title="实体海报" v-if="data.channel==='1'&&data.poster_days!==''">
    <van-cell title="展出时间">
        {{data.poster_start}}至{{data.poster_end}}共计{{data.poster_days}}天（最长7天）
    </van-cell>
    <van-cell title="展出地址" v-model="data.poster_position_name"></van-cell>
    <van-cell title="上传小样" v-if="isJSON(data.poster_demo)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.poster_demo)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
</ax-panel>
<ax-panel title="电子屏" v-if="data.channel==='1'&&data.elec_days!==''">
    <van-cell title="展出时间">
        {{data.elec_start}}至{{data.elec_end}}共计{{data.elec_days}}天（最长14天）
    </van-cell>
    <van-cell title="展出地址">
        A座南北大堂、B座南北大堂
    </van-cell>
    <van-cell title="上传图片" v-if="isJSON(data.elec_demo)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.elec_demo)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
</ax-panel>
<ax-panel title="360家Banner" v-if="data.channel==='2'">
    <van-cell title="展出时间">
        {{data.banner_start}}-{{data.banner_end}}
    </van-cell>
    <van-cell title="上传小样" v-if="isJSON(data.banner_image)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.banner_image)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
    <van-cell title="URL" >
      <a class="link_a"  :href="data.banner_url">{{data.banner_url}}</a>
    </van-cell>
</ax-panel>
<ax-panel title="电梯宣传内容" v-if="data.channel==='3'">
    <van-cell title="展出时间">
        {{data.floor_start}}至{{data.floor_end}}共计{{data.floor_days}}天（最长14天）
    </van-cell>
    <van-cell title="上传图片" >
      <template v-if="data.floor_image" >
       <ax-down v-for="(fileItem, index) in JSON.parse(data.floor_image)" type="ssc" :data="fileItem" :key="index"></ax-down>
      </template>
      <span style="font-size: 12px; color: rgb(195, 129, 7)">
        温馨提示：海报尺寸：768X1366分辨率；视频尺寸：1366X768分辨率 （视频控制在30秒以内）如果是视频文件请上传360办公云盘，上传后在URL中填写分享地址。
        云盘地址：<a class="link_a" style="font-size: 12px;" href="https://pan.qihoo.net/">https://pan.qihoo.net/</a>
      </span>
    </van-cell>
    <van-cell title="URL" >
      <a class="link_a"  :href="data.floor_url">{{data.floor_url}}</a>
    </van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel> `
    ],
    [
        "MFM_1100000019631020",
        `<ax-head v-if="action">
    <div slot="ing">
        <p v-if="data.is_append ==='0'">
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的预算申请单，为<em>{{data.budget_type_name}}</em>申请单，申请金额为<em>{{data.total_budget | money}}</em>（人民币），请您审批。
        </p>
        <p v-else="">
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>追加预算</em>申请单，申请金额为<em>{{data.total_budget | money}}</em>（人民币），请您审批。
        </p>
    </div>
</ax-head>

<ax-panel title="预算类型">
    <van-cell title="预算编号" v-model="data.code"></van-cell>
    <van-cell title="是否为追加预算" v-model="data.is_append_name"></van-cell>
    <van-cell title="主预算编号" v-if="data.is_append !=='0'">
        <router-link class="link_a" :to="'/ssc/complete/details?instId='+data.source_id">
            {{data.source_code}}
        </router-link>
    </van-cell>
    <van-cell title="追加原因" :value="data.append_reason" v-if="data.is_append !=='0'"></van-cell>
</ax-panel>
<ax-panel title="业务/项目信息">
    <van-cell title="是否项目类" v-model="data.is_project_name"></van-cell>
    <van-cell title="业务/项目名称" v-model="data.business_name"></van-cell>
    <van-cell title="业务开始时间" v-model="data.business_begin"></van-cell>
    <van-cell title="业务结束时间" v-model="data.business_end"></van-cell>
    <van-cell title="目标/期望效果" v-model="data.business_goals"></van-cell>
    <van-cell title="是否国拨类" v-if="data.is_project==1" v-model="data.is_gb_name"></van-cell>
</ax-panel>
<ax-panel title="项目信息" v-if="data.is_project == 1">
    <div v-for="(item, index) in data.SUB_bm_budget_project" :key="index">
        <van-cell title="项目编号" v-model="item.project_code"></van-cell>
        <van-cell title="项目名称" v-model="item.project_name"></van-cell>
        <van-cell title="收入金额" v-if="item.income_amount" >{{item.income_amount | money}}</van-cell>
        <van-cell title="IOT毛利率" v-if="item.iot_gross_margin">{{item.iot_gross_margin | money}}</van-cell>
        <van-cell title="销售毛利率" v-if="item.sale_gross_margin" >{{item.sale_gross_margin | money}}</van-cell>
        <van-cell title="占用预算金额" > {{item.occupy_budget_amount | money}}</van-cell>
    </div>
</ax-panel>
<ax-panel title="预算费用">
    <van-cell title="预算内外" v-model="data.budget_type_name"></van-cell>
    <van-cell title="费用部门" v-model="data.use_dept_name"></van-cell>

    <van-cell title="预算类型" v-model="data.budget_type_tree_name"></van-cell>
    <van-cell title="预算年季度">
        {{data.budget_year }} Q{{data.budget_q}}
    </van-cell>
    
    <van-cell title="预算备注" v-model="data.budget_remark"></van-cell>
    <van-cell title="本单预算总金额">
        {{data.total_budget | money}}
    </van-cell>
    <van-cell title="预算费用说明" v-model="data.budget_cost_explanation"></van-cell>
</ax-panel>
<ax-panel title="预算整体情况" v-if="data.is_append !=='0'">
    <van-cell title="主预算金额" v-model="budget.sourceBudget"></van-cell>
    <van-cell title="追加预算总金额" v-model="budget.appendTotalBudget"></van-cell>
    <van-cell title="预算总金额" v-model="budget.totalBudget"></van-cell>
    <van-cell title="累计已使用金额" v-model="budget.usedBudget"></van-cell>
    <van-cell title="在途预提金额" v-model="budget.prepareBudget"></van-cell>
    <van-cell title="剩余金额" v-model="budget.lastBudget"></van-cell>
    <van-cell title="执行情况" v-model="budget.executeState"></van-cell>
</ax-panel>
<ax-panel title="费用明细">
    <div v-for="(item, index) in data.SUB_bm_budget_detail" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="说明项" v-model="item.description"></van-cell>
        <van-cell title="项目编码" v-model="item.project_code"></van-cell>
        <van-cell title="项目名称" v-model="item.project_name"></van-cell>
        <van-cell title="国拨项目预算类" v-model="item.gb_project_type_name"></van-cell>
        <van-cell title="数量" v-model="item.number"></van-cell>
        <van-cell title="单位" v-model="item.unit"></van-cell>
        <van-cell title="单价（RMB）" v-model="item.price"></van-cell>
        <van-cell title="金额（RMB）" v-model="item.amount"></van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000026181016",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em v-if="data.framework==='0'">非框架</em><em v-else="">框架</em>支出合同申请单，为<em >{{data.name}}</em>合同申请，申请金额为<em>{{data.amount | money}}</em>（{{data.currency_unit_name}}），请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="合同属性">
    <van-cell title="合同类型" v-model="data.type_name"></van-cell>
    <van-cell title="合同语言" v-model="data.language_name"></van-cell>
</ax-panel>
<ax-panel title="合同分类">
    <van-cell title="合同分类" v-model="data.label_name"></van-cell>
    <van-cell title="合同明细" v-model="data.sub_label_name"></van-cell>
</ax-panel>

<ax-panel title="合同信息">
    <van-cell title="合同名称" v-model="data.name"></van-cell>
    <div v-if="data.prepayments_name !== '否'">
        <van-cell title="合同期间" v-if="data.start&&data.end">
            {{data.start}}至{{data.end}}
        </van-cell>
    </div>
    <div v-else="">
        <van-cell title="合同起止日期">
            {{data.period_desc}}
        </van-cell>
    </div>
    <van-cell title="合同金额">
        {{data.amount | money}}
    </van-cell>
    <van-cell title="合同币种">
        {{data. currency_unit_name}}({{data.currency_unit}})
    </van-cell>
    <van-cell title="定价方式" v-model="data.pricing_method" v-if="data.pricing_method!==''"></van-cell>
    <ax-fold>
        <van-cell title="是否预付款" v-model="data.prepayments_name"></van-cell>
        <van-cell title="支出类型" v-model="data.expenditure_type_name"></van-cell>
        <van-cell title="费用部门" v-model="data.cost_dept_name"></van-cell>
        <van-cell title="合同内容摘要" v-model="data.summary"></van-cell>
    </ax-fold>
</ax-panel>

<ax-panel title="主体信息">
    <van-cell title="我方主体名称" v-model="data.our_companies_name"></van-cell>
    <van-cell class="top-item" title="对方主体："></van-cell>
    <div v-for="(item, index) in data.SUB_cm_contract_companies" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'主体'+(index+1)+'名称'" v-model="item.name"></van-cell>
        <van-cell title="是否关联方" v-model="item.is_rpt"></van-cell>
        <van-cell title="关联方申请单" v-if="item.is_rpt==='是'">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.rpt_inst_id">
                {{item.rpt_name}}
            </router-link>
        </van-cell>
        <van-cell title="风险主体" v-model="item.in_blacklist_name"></van-cell>
        <van-cell title="关联交易对象评估申请单" v-model="item.bcm_blacklist_flow_name"></van-cell>
    </div>
</ax-panel>

<ax-panel title="预算信息" v-if="data.SUB_cm_contract_budget.length">
    <div v-for="(item, index) in data.SUB_cm_contract_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" :value="item.business_name_name"></van-cell>
        <van-cell title="预算来源">{{item.source}}</van-cell>
        <van-cell title="预算使用金额">{{item.amount | money}}</van-cell>
        <van-cell title="预算使用情况">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.code">查看</router-link>
        </van-cell>
    </div>
</ax-panel>

<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index"></ax-down>   
</ax-panel>

<ax-panel title="财务回填信息" v-if="permission.our_standard_template_form==='w'">
    <van-cell title="是否我方标准模板" class="radio_box" :class="{ 'errors_box':errors.has('standard')}">
        <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>
<ax-panel title="法务回填信息" v-if="permission.tags_form==='w'||permission.important_form==='w'">
    <van-cell title="是否重大合同" class="radio_box" :class="{ 'errors_box':errors.has('important')}" v-if="permission.important_form==='w'">
        <van-radio-group v-model="data.important" v-validate="'required'" name="important">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <div v-if="permission.tags_form === 'w'">
        <van-cell title="选择合同标签" :class="{ 'errors_box':errors.has('tags')}">
          <van-checkbox-group v-model="data.tags" v-validate="'required'" name="tags">
            <van-checkbox
              v-for="(item, index) in expOptions"
              :key="index"
              :name="item.value"
            >
              {{ item.label }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell>
        <van-cell-group v-if="data.tags&&data.tags.includes('112')">
          <van-field
            class="top-item"
            label="其他标签"
            :error= "errors.has('tagsOther')"
            v-model="data.tags_other" 
            placeholder="选择其他，请手填标签" 
            name="tagsOther"
            clearable
            v-validate="{ required: data.tags&&data.tags.includes('112') }" 
          />
        </van-cell-group>
    </div>
</ax-panel>

<ax-panel title="审批信息" v-if="bpmTask.name==='财务三审（子公司）'">
    <van-cell title="是否重大事项" class="radio_box" :class="{ 'errors_box':errors.has('isMajor')}" >
        <van-radio-group v-model="data.is_major" v-validate="'required'" name="isMajor">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000027131019",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>{{data.type_name}}关联方申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="基础信息">
    <van-cell title="申请编号" v-model="data.application_number"></van-cell>
    <van-cell title="对方公司名称">
        {{data.other_company_name}}
    </van-cell>
    <van-cell title="产品">
        {{data.project_name}}
    </van-cell>
    <van-cell title="合同期限" v-if="data.contract_start_date&&data.contract_end_date">
        {{data. contract_start_date}}至{{data.contract_end_date}}
    </van-cell>
    <van-cell title="交易类型" v-model="data.transaction_type_name"></van-cell>
    <van-cell title="交易类型补充">
        {{data.suppy_transaction_type}}
    </van-cell>
</ax-panel>
<ax-panel title="合同内容摘要">
    <van-cell title="我公司取得服务、产品">
        {{data.our_company_obtains_service}}
    </van-cell>
    <van-cell title="我公司提供服务、产品">
        {{data.our_company_provide_service}}
    </van-cell>
    <van-cell title="支付费用或收取费用">
        {{data.transaction_cost}}
    </van-cell>
    <van-cell title="收费标准">
        {{data.charge_standard}}
    </van-cell>
    <van-cell title="预计交易金额">
        {{data.estimated_transaction_amount}}
    </van-cell>
    <ax-fold>
        <van-cell title="结算方式">
            {{data.settlement_method}}
        </van-cell>
        <van-cell title="执行情况衡量">
            {{data.performance_measurement}}
        </van-cell>
        <van-cell title="交易目的">
            {{data.transaction_purpose}}
        </van-cell>
        <van-cell title="定价说明">
            {{data.transaction_pricing_desc}}
        </van-cell>
        <van-cell title="备注" v-show="data.remark!==''">
            {{data.remark}}
        </van-cell>
    </ax-fold>
</ax-panel>
<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index"></ax-down>   
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>

<ax-panel title="关联关系" v-if="permission.relative_desc_form==='w'">            
    <textarea class="comments_box" rows="5" v-model="data.relative_desc" placeholder="请填写关联关系"></textarea>
</ax-panel>`
    ],
    [
        "MFM_1100000028822059",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em v-if="data.framework==='0'">非框架</em><em v-else="">框架</em>免费合同申请单，为<em>{{data.name}}</em>{{data.type_name}}，<span v-if="data.amount_adjust">申请金额为<em>{{data.amount_adjust | money}}</em>（{{data.currency_unit}}），</span>请您审批。            
            </p>
        </div>
        
    </ax-head>

<ax-panel title="协议属性">
    <van-cell title="合同类型" v-model="data.type_name"></van-cell>
    <van-cell title="合同语言" v-model="data.language_name"></van-cell>
    
    <van-cell title="合同分类" v-model="data.label_name"></van-cell>
    <van-cell title="合同明细" v-model="data.sub_label_name"></van-cell>

    <van-cell title="关联原合同">
        <router-link class="link_a" :to="'/ssc/complete/details?instId='+data.source_inst_id">
            {{data.source_name}}
        </router-link>
    </van-cell>
    <van-cell title="原合同附件" v-if="isJSON(data.source_file)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.source_file)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
    <van-cell title="合同编号" :value="data.code"></van-cell>
</ax-panel>
<ax-panel title="协议信息">
    <div v-if="data.type_name!== '终止协议'">
        <van-cell title="协议名称" v-model="data.name"></van-cell>
        <van-cell title="协议期间" v-if="data.start">
            {{data.start}}至{{data.end}}
        </van-cell>
        <van-cell title="费用部门" v-model="data.cost_dept_name"></van-cell>
        <van-cell title="协议与主合同差异说明" v-model="data.difference"></van-cell>
    </div>
    <div v-else="">
        <van-cell title="协议名称" v-model="data.termination_name"></van-cell>
        <van-cell title="生效日期" v-if="data.termination_effective_date">
            {{data.termination_effective_date}}
        </van-cell>
        <van-cell title="协议说明" v-model="data.termination_desc"></van-cell>
    </div>
</ax-panel>
<ax-panel title="主体信息">
    <van-cell title="我方主体名称" v-model="data.our_companies_name"></van-cell>
    <van-cell class="top-item" title="对方主体："></van-cell>
    <div v-for="(item, index) in data.SUB_cm_contract_companies" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'主体'+(index+1)+'名称'" v-model="item.name"></van-cell>
        <van-cell title="是否关联方" v-model="item.is_rpt"></van-cell>
        <van-cell title="关联方申请单" v-if="item.is_rpt==='是'">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.rpt_inst_id">
                {{item.rpt_name}}
            </router-link>
        </van-cell>
        <van-cell title="风险主体" v-model="item.in_blacklist_name"></van-cell>
        <van-cell title="关联交易对象评估申请单" v-model="item.bcm_blacklist_flow_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_cm_contract_budget.length">
    <div v-for="(item, index) in data.SUB_cm_contract_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" :value="item.business_name_name"></van-cell>
        <van-cell title="预算来源">{{item.source}}</van-cell>
        <van-cell title="预算使用金额">{{item.amount | money}}</van-cell>
        <van-cell title="预算使用情况">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.code">查看</router-link>
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index" ></ax-down>   
</ax-panel>

<ax-panel title="财务回填信息" v-if="permission.our_standard_template_form==='w'||permission.income_type_form==='w'">
    <van-cell title="是否我方标准模板" class="radio_box" :class="{ 'errors_box':errors.has('standard')}">
        <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <ax-select label="收入类型" v-model="data.income_type" :options="incomeValues" v-if="permission.income_type_form==='w'" :class="{ 'errors_box':errors.has('incomeType')}" v-validate="'required'" name="incomeType"></ax-select>
    <van-cell title="收入类型" v-if="permission.income_type_form!=='w'&&data.income_type_name" v-model="data.income_type_name"></van-cell>
</ax-panel>
<ax-panel title="法务回填信息" v-if="permission.tags_form==='w'||permission.important_form==='w'">
    <van-cell title="是否重大合同" class="radio_box" :class="{ 'errors_box':errors.has('important')}" v-if="permission.important_form==='w'">
        <van-radio-group v-model="data.important" v-validate="'required'" name="important">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <div v-if="permission.tags_form === 'w'">
        <van-cell title="选择合同标签" :class="{ 'errors_box':errors.has('tags')}">
          <van-checkbox-group v-model="data.tags" v-validate="'required'" name="tags">
            <van-checkbox
              v-for="(item, index) in freeOptions"
              :key="index"
              :name="item.value"
            >
              {{ item.label }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell>
        <van-cell-group v-if="data.tags&&data.tags.includes('309')">
          <van-field
            label="其他标签"
            :error= "errors.has('tagsOther')"
            v-model="data.tags_other" 
            placeholder="选择其他，请手填标签" 
            name="tagsOther"
            clearable
            v-validate="{ required: data.tags&&data.tags.includes('309') }" 
          />
        </van-cell-group>
    </div>
</ax-panel>

<ax-panel title="审批信息" v-if="bpmTask.name==='财务三审（子公司）'">
    <van-cell title="是否重大事项" class="radio_box" :class="{ 'errors_box':errors.has('isMajor')}" >
        <van-radio-group v-model="data.is_major" v-validate="'required'" name="isMajor">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000028832539",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>合并付款申请单</em>，为<em>支出付款</em>申请，总共<em>{{data.SUB_ap_payment_merge_info.length}}</em>笔，申请金额为<em>{{data.sum_amount | money }}</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="财务意见">
    <van-cell title="提交人" v-model="startUser.fullname"></van-cell>
    <van-cell title="总金额">
        {{ data.sum_amount | money}}
    </van-cell>
    <van-cell title="财务具体意见" v-model="data.comment"></van-cell>
</ax-panel>
<ax-panel title="付款信息" v-if="data.SUB_ap_payment_merge_info.length">
    <div v-for="(item, index) in data.SUB_ap_payment_merge_info" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'单号'+(index+1)">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.ref_inst_id">
                {{item.payment_number}}
            </router-link>
        </van-cell>
        <van-cell title="付款摘要" v-model="item.payment_summary"></van-cell>
        <van-cell title="金额">
            {{item.total_money | money}}
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000033372540",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>付款申请单</em>，为<em>通用付款</em>申请,<span v-if="data.total_money1">申请金额为<em>{{data.total_money1 | money }}</em>（{{data.payment_currency_name}}），</span>请您审批。
        </p>
    </div>
</ax-head>
<ax-panel title="我方付款信息">
    <van-cell title="付款编号" v-model="data.payment_number"></van-cell>
    <van-cell title="付款名称" v-model="data.payment_summary"></van-cell>
    <van-cell title="付款币种" v-model="data.payment_currency_name"></van-cell>
    <van-cell title="支出类型" v-model="data.expense_type_name"></van-cell>
    <van-cell title="付款金额总计">
        {{ data.total_money1| money}}
    </van-cell>
    <ax-fold>
        <van-cell title="RMB金额" v-model="data.local_amount" v-if="data.local_amount"></van-cell>
        <van-cell title="RMB金额大写" v-model="data.local_amount_words" v-if="data.local_amount_words"></van-cell>
        <van-cell title="付款单位" v-model="data.payment_company_name"></van-cell>
        <van-cell title="付款方式" v-model="data.payment_method_name"></van-cell>
        <van-cell v-if="data.cost_ratio !== ''" title="费用占比说明" v-model="data.cost_ratio"></van-cell>
        <van-cell title="是否预付款" v-model="data.is_payment_name"></van-cell>
        <van-cell title="付款情况摘要" v-model="data.payment_remark"></van-cell>
    </ax-fold>
</ax-panel>

<ax-panel title="合同信息">
    <van-cell title="关联合同">
        <router-link class="link_a" v-if="!data.contract_source_system || data.contract_source_system=='SSC'" :to="'/ssc/complete/details?instId='+data.contract_instid">
            {{data.contract_name}}
        </router-link>
        <a v-else  class="link_a"  target="blank" :href="$contract_baseurl+ '/ccrt/search/list?contractNumber='+ data.contract_code"> {{data.contract_name}}</a>   
    </van-cell>
    <van-cell title="合同金额" v-if="data.contract_amount">
        {{ data.contract_amount }}
    </van-cell>
    <van-cell title="合同币种">
        {{ data.contract_currency }}
    </van-cell>
    <van-cell title="是否框架合同">
        {{ data.is_framework_contract }}
    </van-cell>
    <van-cell title="老OA合同编号" v-if="data.old_oa_contract_code">
        {{ data.old_oa_contract_code }}
    </van-cell>
    <van-cell title="付款里程碑" v-if="data.payment_contract_marker_name">
    {{ data.payment_contract_marker_name }}
    </van-cell>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_ap_payment_budget.length">
    <div v-for="(item, index) in data.SUB_ap_payment_budget" :key="index">
        <van-cell :class="{ 'top-item':index!==0}" title="预算项目名称">
            {{item.budget_proj_name}}
        </van-cell>
        <van-cell title="项目预算编码" v-model="item.budget_proj_name_code"></van-cell>
        <van-cell title="预算来源" v-model="item.budget_source"></van-cell>
        <van-cell title="剩余金额" v-if="item.surplus_amout">
            {{item.surplus_amout }}
        </van-cell>
        <van-cell title="预算使用金额">
            {{item.occupy_amount | money}}
        </van-cell>
        <van-cell title="预算使用情况">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.budget_proj_name_code">查看详情</router-link>
        </van-cell>
    </div>
</ax-panel>

<ax-panel title="对方收款信息" v-if="data.SUB_ap_payment_receipt.length">
    <div v-for="(item, index) in data.SUB_ap_payment_receipt" :key="index">
        <van-cell :class="{ 'top-item':index!==0}" title="收款单位/人" v-model="item.company"></van-cell>
        <van-cell title="开户银行" v-model="item.open_bank_name"></van-cell>
        <van-cell title="支行银行名称" v-model="item.branch_bank_name"></van-cell>
        <van-cell title="收款银行账号" v-model="item.bank_account"></van-cell>
        <van-cell title="省" v-model="item.province"></van-cell>
        <ax-fold>
            <van-cell title="市" v-model="item.city"></van-cell>
            <van-cell title="预提编号" v-if="item.accrued_code_name">
                {{item.accrued_code_name}}
            </van-cell>
            <van-cell title="预提金额" v-if="item.accrued_money">
                {{item.accrued_money | money}}
            </van-cell>
            <van-cell title="金额">
                {{item.money_account | money}}
            </van-cell>
            <van-cell title="财务确认金额">
                {{item.fina_confir_amount | money}}
            </van-cell>
            <van-cell title="业务发生日期" v-model="item.actual_start_date"></van-cell>
            <van-cell title="业务编码" v-model="item.bussiness_code"></van-cell>
            <van-cell title="费用类型" v-model="item.expense_type_name"></van-cell>
            <van-cell title="项目类型" v-model="item.project_type_name"></van-cell>
            <van-cell title="实际费用归属部门" v-model="item.expense_department_name"></van-cell>
            <van-cell v-if="item.org" title="OU名称" v-model="item.org_name"></van-cell>
            <van-cell v-if="item.invoice_number" title="AP发票" v-model="item.invoice_number"></van-cell>
            <van-cell v-if="item.item_desc !== ''" title="说明项" v-model="item.item_desc"></van-cell>   
            <van-cell v-if="item.ept_payment_date" title="最后付款日期" v-model="item.ept_payment_date"></van-cell>         
            <van-cell title="附件" v-if="isJSON(item.attachment)">
                <ax-down v-for="(fileItem,index) in JSON.parse(item.attachment)" type="ssc" :data="fileItem" :key="index"></ax-down>
            </van-cell>
        </ax-fold>
    </div>
</ax-panel>

<ax-panel title="审批信息" v-if="bpmTask.name==='财务三审（子公司）'">
    <van-cell title="是否重大事项" class="radio_box" :class="{ 'errors_box':errors.has('isMajor')}" >
        <van-radio-group v-model="data.is_major" v-validate="'required'" name="isMajor">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000047442013",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>手机邮箱申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="责任声明" >
    <van-cell class="paddingl" value="1、公司手机邮箱为了方便大家工作，请按需申请、审批手机邮箱权限；"></van-cell>
    <van-cell class="paddingl" value="2、若因申请人使用手机邮箱时故意或无意的行为，导致公司内网被入侵或敏感信息外泄，审批人与申请人共同承担责任。"></van-cell>
</ax-panel>

<ax-panel title="申请信息">
    <van-cell title="设备数量" :value="data.equipment_amount_name"></van-cell>
    <van-cell title="温馨提醒" value="日常办公只允许申请1台设备，开发测试类允许申请1台以上设备。"></van-cell>
    <van-cell title="申请原因" v-if="data.apply_cause" :value="data.apply_cause"></van-cell>
    <van-cell title="附件" >
      <router-link  class="link_a" to="/pdfH5/iphoneEmail">手机邮箱配置手册 </router-link >
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1200000000112075",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>合并实际付款单</em>共计<em>{{data.SUB_ap_check_merge_info.length}}</em>笔实际付款单，<span v-if="data.sum_amount">总金额为<em>{{data.sum_amount | money }}</em>（人民币），</span>请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="相关信息">
    <van-cell title="合并付款单编号" v-model="data.code"></van-cell>
    <van-cell v-if="data.comment" title="财务补充意见" v-model="data.comment"></van-cell>
</ax-panel>
<ax-panel title="付款信息" v-if="data.SUB_ap_check_merge_info.length">
    <div v-for="(item,index) in data.SUB_ap_check_merge_info" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="付款编码">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.ref_inst_id">
                {{item.payment_number}}
            </router-link>
        </van-cell>
        <van-cell title="币种" v-model="item.payment_currency_name"></van-cell>
        <van-cell title="金额" v-if="item.money_account">
            {{item.money_account | money}}
        </van-cell>
        <van-cell title="RMB金额" v-if="item.cny_money">
            {{item.cny_money | money}}
        </van-cell>
    </div>
    <div>
        <van-cell class="top-item" title="RMB金额总计" v-if="data.sum_amount">
            {{data.sum_amount | money}}
        </van-cell>
        <van-cell title="金额大写" v-model="data.zh_sum_amount"></van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel> `
    ],
    [
        "MFM_1200000000191754",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的用户权限申请单，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="基础信息">
    <van-cell title="操作类型" :value="data.opt_type_name"></van-cell>
    <van-cell title="是否代为申请" :value="data.is_rep_apply_name"></van-cell>
    <van-cell title="系统名称" :value="data.systemauth_name"></van-cell>
    <van-cell title="权限说明" :value="data.description"></van-cell>
    <van-cell title="是否需要VP审批" v-if="permission.is_required_vp_form==='w'" class="radio_box" :class="{ 'errors_box':errors.has('requiredVp')}">
        <van-radio-group v-model="data.is_required_vp" class="radio_box" v-validate="'required'" name="requiredVp">
            <van-radio v-for="(item, index) in vpOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>
<ax-panel title="用户信息" v-if="data.SUB_au_userinfo.length">
    <div v-for="(item, index) in data.SUB_au_userinfo" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="使用人姓名" v-model="item.name"></van-cell>
        <van-cell title="账户名" v-model="item.account"></van-cell>
        <van-cell title="注册邮箱" v-model="item.register_mail"></van-cell>
        <van-cell title="使用人邮箱" v-model="item.user_mail"></van-cell>
        <van-cell title="使用人手机" v-model="item.phone"></van-cell>
        <van-cell title="账号使用性质" v-model="item.account_type_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1200000000191938",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>数据权限查询申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>
<ax-panel title="基础信息">
    <van-cell title="数据权限/QDAS名称" :value="data.data_permission_name"></van-cell>
    <van-cell title="申请原因" :value="data.reason"></van-cell>
    <van-cell title="申请查看报表申请" :value="data.notes"></van-cell>
    <van-cell title="是否需要VP审批" v-if="permission.is_required_vp_form==='w'" class="radio_box" :class="{ 'errors_box':errors.has('requiredVp')}">
        <van-radio-group v-model="data.is_required_vp" class="radio_box" v-validate="'required'" name="requiredVp">
            <van-radio v-for="(item, index) in vpOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1200000000220820",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的合同借阅申请单，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="借阅信息">
    <van-cell title="合同编号" :value="data.contract_number"></van-cell>
    <van-cell title="合同名称" :value="data.contract_name"></van-cell>
    
    <van-cell title="合同分类" v-model="data.label_name"></van-cell>
    <van-cell title="合同明细" v-model="data.sub_label_name"></van-cell>

    <van-cell title="签约主体" :value="data.sign_body_name"></van-cell>
    <van-cell title="合同主要内容" :value="data.content"></van-cell>
    <van-cell title="申请类型" :value="data.apply_type_name"></van-cell>
    <ax-fold>
        <van-cell v-if="data.return_date" title="归还时间" :value="data.return_date"></van-cell>
        <van-cell title="跨部门借阅" :value="data.cross_dept_borrow_name"></van-cell>
        <van-cell v-if="data.cross_dept_borrow ==='1'" title="选择部门" :value="data.select_dept_name"></van-cell>
        <van-cell title="用途说明" :value="data.usage_description"></van-cell>
        <van-cell title="注意事项："></van-cell>
        <van-cell>
            （1）合同本身及其内容系公司保密信息，仅可用于经公司批准的用途，未经公司允许，任何人不得擅自使用或披露，如需对外披露，应先签订保密协议。
        </van-cell>
        <van-cell>
            （2）除法院、税务局等特殊对公事务外，原则上不允许借阅合同原件。
        </van-cell>
        <van-cell>
            （3）无特殊对公事务，复印件/扫描件均应加水印。
        </van-cell>
        <van-cell>
            （4）如合同经办部门已经与其他部门合并、分立的，则由合并、分立后的部门主管副总裁作为合同经办部门主管副总裁审批确认；如合同经办部门已经被撤销的，则由总裁审批确认。
        </van-cell>
        <van-cell>
            （5）内审部、道德委员会、财务中心、法务部和上市法律部在各自职权分工范围内调取其他部门合同的，由其各自部门主管副总裁审批确认，不需要跨部门审批。
        </van-cell>
        <van-cell>
            （6）如合同提供过程中，需要加盖公章，则需申请人另行申请公章审批流程。
        </van-cell>
        <van-cell title=" ">{{data.is_agree_name}}</van-cell>
    </ax-fold>
</ax-panel>
<ax-panel title="借阅附件" v-if="isJSON(data.borrow_attach)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.borrow_attach)" type="ssc" :data="fileItem" :key="index"></ax-down>   
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1200000000323061",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>IT电子设备/耗材申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="相关信息">
    <van-cell title="申请单编号" v-model="data.code"></van-cell>
    <van-cell title="使用方式" v-model="data.use_method_name"></van-cell>
    <van-cell v-if="data.return_date" title="预计归还时间" v-model="data.return_date"></van-cell>
</ax-panel>
<ax-panel title="申请明细" v-if="data.SUB_itdb_device_detail.length">
    <div v-for="(item, index) in data.SUB_itdb_device_detail" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="员工类型" v-model="item.employee_category_name"></van-cell>
        <van-cell title="使用人" v-model="item.use_user_name"></van-cell>
        <van-cell title="申请类别" v-model="item.category_name"></van-cell>
        <van-cell title="申请设备名称" v-model="item.name_name"></van-cell>
        <van-cell title="数量" v-model="item.quantity"></van-cell>
        <van-cell title="参考价格(元)" v-model="item.price"></van-cell>
        <ax-fold>
            <van-cell title="用途" v-model="item.purpose_name"></van-cell>
            <van-cell title="资产责任人" v-model="item.owner_name"></van-cell>
            <van-cell v-if="item.sn" title="SN号" v-model="item.sn"></van-cell>
            <van-cell v-if="item.provide_way_name" title="提供方式" v-model="item.provide_way_name"></van-cell>
            <van-cell v-if="item.delivery_name" title="是否已发放" v-model="item.delivery_name"></van-cell>
            <van-cell v-if="item.special_name" title="是否特殊商品、高价值、苹果设备" v-model="item.special_name"></van-cell>

            <van-cell v-if="item.allocate_name" title="配给设备名称" v-model="item.allocate_name"></van-cell>
            <van-cell v-if="item.allocate_price" title="配给参考价格" v-model="item.allocate_price"></van-cell>
            <van-cell v-if="item.number_name" title="配给资产编号" v-model="item.number_name"></van-cell>

            <van-cell v-if="item.description&&item.description!==''" title="说明" v-model="item.description"></van-cell>
            <van-cell v-if="item.source_number_name&&item.source_number_name!==''" title="所属资产编号" v-model="item.source_number_name"></van-cell>
        </ax-fold>
    </div>
    <van-cell class="top-item" title="需求明细" v-model="data.detail"></van-cell>
    <van-cell title="申请原因" v-model="data.reason"></van-cell>
</ax-panel>
<ax-panel title="旧设备信息" v-if="data.SUB_itdb_device_old.length&&data.use_method === '126'">
    <div v-for="(item, index) in data.SUB_itdb_device_old" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="资产编号" v-model="item.number_name"></van-cell>
        <van-cell title="SN号" v-model="item.sn"></van-cell>
        <van-cell title="使用人" v-model="item.use_user"></van-cell>
        <van-cell title="资产设备名称" v-model="item.name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1200000000361770",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>工卡补办申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="工卡详情">
    <van-cell title="申请人域名" v-model="data.domain_name"></van-cell>
    <van-cell title="员工性质" v-model="data.employee_nature"></van-cell>
    <van-cell title="申请原因" v-model="data.reason"></van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1200000000920282",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>物品放行申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="申请详情">
    <van-cell title="出门日期" v-model="data.go_out_time"></van-cell>
    <van-cell title="物品类型" v-model="data.goods_type_name"></van-cell>
    <van-cell title="运送目的地" v-model="data.transport_dest"></van-cell>
    <van-cell title="申请说明" v-model="data.comment"></van-cell>
    <van-cell title="照片上传" v-if="isJSON(data.photo)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.photo)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
</ax-panel>
<ax-panel title="物品明细" v-if="data.SUB_ad_goods_info.length">
    <div v-for="(item, index) in data.SUB_ad_goods_info" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="物品描述" v-model="item.goods_desc"></van-cell>
        <van-cell title="资产号" v-model="item.property_no"></van-cell>
        <van-cell title="系列号" v-model="item.series_no"></van-cell>
        <van-cell title="数量" v-model="item.quantity"></van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1200000001202007",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>产品推广价格政策申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="基本信息">
    <van-cell title="价格政策" v-model="data.price_policy_name"></van-cell>
    <van-cell title="产品线负责人" v-model="data.product_leader_name"></van-cell>
    <van-cell title="价格生效时间">
        从{{data.price_start_date}}至{{data.price_end_date}}
    </van-cell>
    <van-cell title="价格政策涉及的产品" v-model="data.involved_product"></van-cell>
    <van-cell title="价格政策内容定价参考依据" v-model="data.reference_license"></van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1200000001220067",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>广告联盟特殊价格调整申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="客户信息">
    <van-cell title="是否为联盟KA客户单价调整" v-model="data.is_ka_name"></van-cell>
    <van-cell v-if="data.is_ka==='1'" title="KA客户名称" v-model="data.ka_name"></van-cell>
    <van-cell v-if="data.is_ka==='1'" title="是否新增客户" v-model="data.is_newcustomer_name"></van-cell>
    <van-cell v-if="data.is_ka==='2'" title="客户类型" v-model="data.customer_type_name"></van-cell>
</ax-panel>
<ax-panel title="账户信息" v-if="data.is_ka === '2'">
    <van-cell title="账户名称" v-model="data.account"></van-cell>
    <van-cell title="广告类型" v-model="data.adv_type_name"></van-cell>
    <van-cell title="网站域名/应用名称" v-model="data.adv_name"></van-cell>
    <van-cell v-if="data.app_name" title="应用包名" v-model="data.app_name"></van-cell>
</ax-panel>
<ax-panel title="价格信息" v-if="data.is_ka === '1'">
    <van-cell title="申请价格" v-model="data.apply_price"></van-cell>
</ax-panel>
<ax-panel title="价格信息" v-else="">
    <van-cell title="采购方式" v-model="data.purcase_way_name"></van-cell>
    <van-cell title="是否独家" v-model="data.is_onlyone_name"></van-cell>
    <van-cell title="采购价格" v-model="data.purcase_price"></van-cell>
    <van-cell title="分成比例" v-model="data.component_ratio"></van-cell>
    <van-cell title="是否价格政策内" v-model="data.is_price_policy_name"></van-cell>
</ax-panel>
<ax-panel title="投放信息" v-if="data.is_ka === '2'">
    <van-cell title="对接方式" v-model="data.dock_mode_name"></van-cell>
    <van-cell title="合作形式" v-model="data.ways_cooperation_name"></van-cell>
</ax-panel>
<ax-panel title="广告数据" v-if="data.is_ka === '1'">
    <van-cell title="变更说明" v-model="data.changes_notes"></van-cell>
</ax-panel>
<ax-panel title="广告数据" v-else="">
    <van-cell title="流量（UV）" v-model="data.uv"></van-cell>
    <van-cell title="广告展示" v-model="data.adv_volume"></van-cell>
    <van-cell title="变更说明" v-model="data.changes_notes"></van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_2400000015301130",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>VPN授权申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="相关信息">
        <van-cell title="申请类别" :value="data.vpn_type_name"></van-cell>
        <van-cell title="申请原因" :value="data.reason"></van-cell>
        <div v-if="permission.remind_approver_form==='w'">
            <van-cell title="提醒事项" :class="{ 'errors_box':errors.has('standard')}">
                <div style="text-align:left; padding-top:10px;">
                    1, VPN系统是为了便于用户经Internet远程访问公司内部网络而设立，但由于用户客户端计算机
的安全性不可控制，可能会影响内部网络安全，请慎重审批VPN使用权限<br/>2, 因员工泄露vpn密码与在不安全的客户端使用导致内网安全入侵，由员工本人及其审批上级
承担责任
                </div>
                <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
                    <van-radio v-for="(item, index) in agreeOptions" :key="index" :name="item.value">
                        <span style="color: #FA5151;">{{item.label}}</span>
                    </van-radio>
                </van-radio-group>
            </van-cell>
        </div>
        <div v-else="">
            <van-cell title="审批事项">
                1, VPN系统是为了便于用户经Internet远程访问公司内部网络而设立，但由于用户客户端计算机
的安全性不可控制，可能会影响内部网络安全，请慎重审批VPN使用权限<br/>2, 因员工泄露vpn密码与在不安全的客户端使用导致内网安全入侵，由员工本人及其审批上级
承担责任
                <div>
                    {{data.remind_approver_name}}
                </div>
            </van-cell>
        </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_2430000015601105-01",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>预算申请单(手游代金券)</em>，申请金额为<em>{{data.total_budget | money}}</em>（人民币），请您审批。
            </p>
        </div>
    </ax-head>

<ax-panel title="业务/项目信息">
    <van-cell title="游戏业务线" v-model="data.game_line_name"></van-cell>
    <van-cell title="业务/项目名称" v-model="data.business_name"></van-cell>
    <van-cell title="业务开始时间" v-model="data.business_begin"></van-cell>
    <van-cell title="业务结束时间" v-model="data.business_end"></van-cell>
    <van-cell title="目标/期望效果" v-model="data.business_goals"></van-cell>
</ax-panel>
<ax-panel title="项目信息" v-if="data.is_project == 1">
    <div v-for="(item, index) in data.SUB_bm_budget_project" :key="index">
        <van-cell title="项目编号" v-model="item.project_code"></van-cell>
        <van-cell title="项目名称" v-model="item.project_name"></van-cell>
        <van-cell title="收入金额" v-if="item.income_amount" >{{item.income_amount | money}}</van-cell>
        <van-cell title="IOT毛利率" v-if="item.iot_gross_margin">{{item.iot_gross_margin | money}}</van-cell>
        <van-cell title="销售毛利率" v-if="item.sale_gross_margin" >{{item.sale_gross_margin | money}}</van-cell>
        <van-cell title="占用预算金额" > {{item.occupy_budget_amount | money}}</van-cell>
    </div>
</ax-panel>
<ax-panel title="预算费用">
    <van-cell title="本单预算总金额">
        {{data.total_budget | money}}
    </van-cell>
    <van-cell title="预算内外" v-model="data.budget_type_name"></van-cell>
    <van-cell title="费用部门" v-model="data.use_dept_name"></van-cell>
    <van-cell title="预算类型" v-model="data.budget_type_tree_name"></van-cell>
    <van-cell title="代金券是否分成" v-if="data.is_divide_into" v-model="data.is_divide_into_name"></van-cell>
    <van-cell title="预算年季度">
        {{data.budget_year }} Q{{data.budget_q}}
    </van-cell>
    <van-cell title="预算费用说明" v-model="data.budget_cost_explanation"></van-cell>
    <van-cell title="预算备注" v-model="data.budget_remark"></van-cell>
</ax-panel>
<ax-panel title="游戏信息">
    <div v-for="(item, index) in data.SUB_bm_budget_mobile_games_list" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="appkey" v-model="item.appkey"></van-cell>
        <van-cell title="游戏名称" v-model="item.game_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="代金券信息">
    <div v-for="(item, index) in data.SUB_bm_budget_cash_coupon" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="分享类型" v-model="item.share_type_name"></van-cell>
        <van-cell title="预估发放面额">
            ￥{{item.give_out_denomination | money}}
        </van-cell>
        <van-cell title="预估消耗率(%)" v-model="item.consumption_rate"></van-cell>
        <van-cell title="预估消耗面额">
            ￥{{item.consume_denomination | money}}
        </van-cell>
        <van-cell title="使用方式" v-model="item.use_type"></van-cell>
        <van-cell title="效果预估" v-model="item.effect"></van-cell>
        <van-cell title="预估产生成本">
            ￥{{item.estimate_cost | money}}
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel> `
    ],
    [
        "MFM_2430000015601105",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>IoT预算申请单</em>，为<em>{{data.budget_type_name}}</em>申请单，申请金额为<em>{{data.total_budget | money}}</em>（人民币），请您审批。
            </p>
        </div>
        
    </ax-head>
    
<ax-panel title="预算类型">
    <van-cell title="预算编号" v-model="data.code"></van-cell>
    <van-cell title="IoT产品线" v-model="data.iot_line_name"></van-cell>
    <van-cell title="是否追加预算" v-model="data.is_append_name"></van-cell>
    <van-cell v-if="data.is_append=='1'" title="主预算编号" v-model="data.source_code"></van-cell>
    <van-cell title="主预算编号" v-if="data.is_append !=='0'">
        <router-link class="link_a" :to="'/ssc/complete/details?instId='+data.source_id">
            {{data.source_code}}
        </router-link>
    </van-cell>
</ax-panel>
<ax-panel title="业务/项目信息">
    <van-cell title="是否项目类" v-model="data.is_project_name"></van-cell>
    <van-cell title="业务/项目名称" v-model="data.business_name"></van-cell>
    <van-cell title="业务开始时间" v-model="data.business_begin"></van-cell>
    <van-cell title="业务结束时间" v-model="data.business_end"></van-cell>
    <van-cell title="目标/期望效果" v-model="data.business_goals"></van-cell>
</ax-panel>
<ax-panel title="项目信息" v-if="data.is_project == 1">
    <div v-for="(item, index) in data.SUB_bm_budget_project" :key="index">
        <van-cell title="项目编号" v-model="item.project_code"></van-cell>
        <van-cell title="项目名称" v-model="item.project_name"></van-cell>
        <van-cell title="收入金额" v-if="item.income_amount" >{{item.income_amount | money}}</van-cell>
        <van-cell title="IOT毛利率" v-if="item.iot_gross_margin">{{item.iot_gross_margin | money}}</van-cell>
        <van-cell title="销售毛利率" v-if="item.sale_gross_margin" >{{item.sale_gross_margin | money}}</van-cell>
        <van-cell title="占用预算金额" > {{item.occupy_budget_amount | money}}</van-cell>
    </div>
</ax-panel>
<ax-panel title="预算费用">
    <van-cell title="预算内外" v-model="data.budget_type_name"></van-cell>
    <van-cell title="费用部门" v-model="data.use_dept_name"></van-cell>
    <van-cell title="预算类型" v-model="data.budget_type_tree_name"></van-cell>
    <van-cell title="预算年季度">
        {{data.budget_year }} Q{{data.budget_q}}
    </van-cell>
    <van-cell title="预算备注" v-model="data.budget_remark"></van-cell>
    <van-cell title="本单预算总金额">
        {{data.total_budget | money}}
    </van-cell>
    <van-cell title="预算费用说明" v-model="data.budget_cost_explanation"></van-cell>
</ax-panel>
<ax-panel title="费用明细">
    <div v-for="(item, index) in data.SUB_bm_budget_detail" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="说明项" v-model="item.description"></van-cell>
        <van-cell title="数量" v-model="item.number"></van-cell>
        <van-cell title="单位" v-model="item.unit"></van-cell>
        <van-cell title="单价（RMB）" v-model="item.price"></van-cell>
        <van-cell title="金额（RMB）" v-model="item.amount"></van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_2430000015601786",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em v-if="data.framework==='0'">非框架</em><em v-else="">框架</em>IoT合同申请单，为<em>{{data.name}}</em>{{data.type_name}}，<span v-if="data.amount_adjust">申请金额为<em>{{data.amount_adjust | money}}</em>（{{data.currency_unit}}），</span>请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="协议属性">
    <van-cell title="合同类型" v-model="data.type_name"></van-cell>
    <van-cell title="合同语言" v-model="data.language_name"></van-cell>
    
    <van-cell title="合同分类" v-if="data.label_name" v-model="data.label_name"></van-cell>
    <van-cell title="合同明细" v-if="data.sub_label_name"  v-model="data.sub_label_name"></van-cell>

    <van-cell title="IoT产品线" v-model="data.iot_line_name"></van-cell>
    <van-cell title="合同表单类型" v-model="data.iot_category_name"></van-cell>
    <van-cell title="用印地" v-model="data.seal_place_name"></van-cell>
    <van-cell title="是否海外订单" v-if="data.type == 2" v-model="data.is_overseas_order_name"></van-cell>
    <van-cell title="关联原合同">
        <router-link class="link_a" :to="'/ssc/complete/details?instId='+data.source_inst_id">
            {{data.source_name}}
        </router-link>
    </van-cell>
</ax-panel>
<ax-panel title="协议信息">
    <div v-if="data.type_name!== '终止协议'">
        <van-cell title="协议名称" v-model="data.name"></van-cell>
        <van-cell title="协议期间" v-if="data.start">
            {{data.start}}至{{data.end}}
        </van-cell>
        <van-cell title="财务价格调整">
            {{data.price_adjust_name}}
        </van-cell>
        <van-cell title="调整金额" v-if="data.amount_adjust">
            {{data.amount_adjust | money}}
        </van-cell>
        <van-cell title="费用部门" v-model="data.cost_dept_name"></van-cell>
        <van-cell title="协议与主合同差异说明" v-model="data.difference"></van-cell>
    </div>
    <div v-else="">
        <van-cell title="协议名称" v-model="data.termination_name"></van-cell>
        <van-cell title="生效日期" v-if="data.termination_effective_date">
            {{data.termination_effective_date}}
        </van-cell>
        <van-cell title="协议说明" v-model="data.termination_desc"></van-cell>
    </div>
</ax-panel>
<ax-panel title="主体信息">
    <van-cell title="我方主体名称" v-model="data.our_companies_name"></van-cell>
    <van-cell class="top-item" title="对方主体："></van-cell>
    <div v-for="(item, index) in data.SUB_cm_contract_companies" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'主体'+(index+1)+'名称'" v-model="item.name"></van-cell>
        <van-cell title="是否关联方" v-model="item.is_rpt"></van-cell>
        <van-cell title="关联方申请单" v-if="item.is_rpt==='是'">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.rpt_inst_id">
                {{item.rpt_name}}
            </router-link>
        </van-cell>
        <van-cell title="风险主体" v-model="item.in_blacklist_name"></van-cell>
        <van-cell title="关联交易对象评估申请单" v-model="item.bcm_blacklist_flow_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_cm_contract_budget.length">
    <div v-for="(item, index) in data.SUB_cm_contract_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" :value="item.business_name_name"></van-cell>
        <van-cell title="预算来源">{{item.source}}</van-cell>
        <van-cell title="预算使用金额">{{item.amount | money}}</van-cell>
        <van-cell title="预算使用情况">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.code">查看</router-link>
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="项目信息" v-if="data.SUB_cm_contract_project && data.SUB_cm_contract_project.length">
    <div v-for="(item, index) in data.SUB_cm_contract_project" :key="index">
        <van-cell title="项目编号" v-model="item.project_code"></van-cell>
        <van-cell title="项目名称" v-model="item.project_name"></van-cell>
        <van-cell title="收入金额" v-if="item.income_amount" >{{item.income_amount | money}}</van-cell>
        <van-cell title="IOT毛利率" v-if="item.iot_gross_margin">{{item.iot_gross_margin | money}}</van-cell>
        <van-cell title="销售毛利率" v-if="item.sale_gross_margin" >{{item.sale_gross_margin | money}}</van-cell>
        <van-cell title="占用预算金额" v-if="item.occupy_budget_amount"  > {{item.occupy_budget_amount | money}}</van-cell>
    </div>
</ax-panel>
<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index" ></ax-down>   
</ax-panel>

<ax-panel title="财务回填信息" v-if="permission.our_standard_template_form==='w'">
    <van-cell title="是否我方标准模板" class="radio_box" :class="{ 'errors_box':errors.has('standard')}">
        <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>
<ax-panel title="法务回填信息" v-if="permission.tags_form==='w'||permission.important_form==='w'">
    <van-cell title="是否重大合同" class="radio_box" :class="{ 'errors_box':errors.has('important')}" v-if="permission.important_form==='w'">
        <van-radio-group v-model="data.important" v-validate="'required'" name="important">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <div v-if="permission.tags_form === 'w'">
        <van-cell title="选择合同标签" :class="{ 'errors_box':errors.has('tags')}">
          <van-checkbox-group v-model="data.tags" v-validate="'required'" name="tags">
            <van-checkbox
              v-for="(item, index) in expOptions"
              :key="index"
              :name="item.value"
            >
              {{ item.label }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell>
        <van-cell-group v-if="data.tags&&data.tags.includes('112')">
          <van-field
            label="其他标签"
            :error= "errors.has('tagsOther')"
            v-model="data.tags_other" 
            placeholder="选择其他，请手填标签" 
            name="tagsOther"
            clearable
            v-validate="{ required: data.tags&&data.tags.includes('112') }" 
          />
        </van-cell-group>
    </div>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_2430000015602217",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em><em v-if="data.framework==='0'">非框架</em><em v-else="">框架</em>IoT合同申请单，为<em>{{data.name}}</em>合同申请，<span v-if="data.amount">申请金额为<em>{{data.amount | money}}</em>（{{data.currency_unit_name}}），</span>请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="协议属性">
    <van-cell title="合同类型" v-model="data.type_name"></van-cell>
    <van-cell title="合同语言" v-model="data.language_name"></van-cell>
    
    <van-cell title="合同分类" v-if="data.label_name" v-model="data.label_name"></van-cell>
    <van-cell title="合同明细" v-if="data.sub_label_name" v-model="data.sub_label_name"></van-cell>

    <van-cell title="IoT产品线" v-model="data.iot_line_name"></van-cell>
    <van-cell title="合同表单类型" v-model="data.iot_category_name"></van-cell>
</ax-panel>

<ax-panel title="主体信息">
    <van-cell title="我方主体名称" v-model="data.our_companies_name"></van-cell>
    <van-cell class="top-item" title="对方主体："></van-cell>
    <div v-for="(item, index) in data.SUB_cm_contract_companies" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'主体'+(index+1)+'名称'" v-model="item.name"></van-cell>
        <van-cell title="是否关联方" v-model="item.is_rpt"></van-cell>
        <van-cell title="关联方申请单" v-if="item.is_rpt==='是'">
            <router-link class="link_a" :to="'/ssc/complete/details?instId=/'+item.rpt_inst_id">
                {{item.rpt_name}}
            </router-link>
        </van-cell>
        <van-cell title="风险主体" v-model="item.in_blacklist_name"></van-cell>
        <van-cell title="关联交易对象评估申请单" v-model="item.bcm_blacklist_flow_name"></van-cell>
    </div>
</ax-panel>

<ax-panel title="预算信息" v-if="data.SUB_cm_contract_budget.length">
    <div v-for="(item, index) in data.SUB_cm_contract_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" :value="item.business_name_name"></van-cell>
        <van-cell title="预算来源">{{item.source}}</van-cell>
        <van-cell title="预算使用金额">{{item.amount | money}}</van-cell>
        <van-cell title="预算使用情况">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.code">查看</router-link>
        </van-cell>
    </div>
</ax-panel>

<ax-panel title="项目信息" v-if="data.SUB_cm_contract_project && data.SUB_cm_contract_project.length">
    <div v-for="(item, index) in data.SUB_cm_contract_project" :key="index">
        <van-cell title="项目编号" v-model="item.project_code"></van-cell>
        <van-cell title="项目名称" v-model="item.project_name"></van-cell>
        <van-cell title="收入金额" v-if="item.income_amount" >{{item.income_amount | money}}</van-cell>
        <van-cell title="IOT毛利率" v-if="item.iot_gross_margin">{{item.iot_gross_margin | money}}</van-cell>
        <van-cell title="销售毛利率" v-if="item.sale_gross_margin" >{{item.sale_gross_margin | money}}</van-cell>
        <van-cell title="占用预算金额" v-if="item.occupy_budget_amount"  > {{item.occupy_budget_amount | money}}</van-cell>
    </div>
</ax-panel>

<ax-panel title="业务信息">
    <van-cell title="合同名称" v-model="data.name"></van-cell>
    <van-cell title="是否框架合同">
        {{data.framework_name}}
    </van-cell>
    <div v-if="data.prepayments_name !== '否'">
        <van-cell title="合同期间" v-if="data.start&&data.end">
            {{data.start}}至{{data.end}}
        </van-cell>
    </div>
    <div v-else="">
        <van-cell title="合同起止日期">
            {{data.period_desc}}
        </van-cell>
    </div>
    <van-cell title="合同期限">
        {{data.period_name}}
    </van-cell>
    <van-cell title="合同金额" v-if="data.amount">
        {{data.amount | money}}
    </van-cell>
    <ax-fold>
        <van-cell title="合同币种" v-if="data.iot_category !=='3'">
            {{data. currency_unit_name}}({{data.currency_unit}})
        </van-cell>
        <van-cell title="定价方式" v-model="data.pricing_method" v-if="data.pricing_method!==''"></van-cell>
        <van-cell title="是否预付款" v-model="data.prepayments_name" v-if="data.prepayments_name!==''"></van-cell>
        <van-cell title="费用部门" v-model="data.cost_dept_name"></van-cell>
        <van-cell title="合同内容摘要" v-model="data.summary"></van-cell>
    </ax-fold>
</ax-panel>

<ax-panel title="付款信息">
    <van-cell title="合同币种">
        {{data.currency_unit_name}}{{data.currency_unit}}
    </van-cell>
    <van-cell title="合同金额">
        {{ data.amount }}
    </van-cell>
    <van-cell title="定价方式" v-model="data.pricing_method"></van-cell>
    <van-cell title="是否预付款" v-model="data.prepayments_name"></van-cell>
</ax-panel>

<ax-panel title="支出类型" v-if="data.iot_category === '1'">
    <van-cell title="支出类型" v-model="data.expenditure_type_name"></van-cell>
</ax-panel>

<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index" ></ax-down>   
</ax-panel>

<ax-panel title="相关协议" v-if="agreementList.length">
    <div v-for="(item,index) in agreementList">
        <van-cell :class="{'top-item':index!==0}" title="协议编号" v-model="data.code"></van-cell>
        <van-cell title="协议名称" v-model="item.retirement_type_name">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.instId">
                {{item.name}}
            </router-link>
        </van-cell>
        <van-cell title="协议类型" v-model="item.typeName"></van-cell>
    </div>
</ax-panel>

<ax-panel title="财务回填信息" v-if="permission.our_standard_template_form==='w'">
    <van-cell title="是否我方标准模板" class="radio_box" :class="{ 'errors_box':errors.has('standard')}">
        <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>

<ax-panel title="法务回填信息" v-if="permission.tags_form==='w'||permission.important_form==='w'">
    <van-cell title="是否重大合同" class="radio_box" :class="{ 'errors_box':errors.has('important')}" v-if="permission.important_form==='w'">
        <van-radio-group v-model="data.important" v-validate="'required'" name="important">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <div v-if="permission.tags_form === 'w'">
        <van-cell title="选择合同标签" :class="{ 'errors_box':errors.has('tags')}">
          <van-checkbox-group v-model="data.tags" v-validate="'required'" name="tags">
            <van-checkbox
              v-for="(item, index) in expOptions"
              :key="index"
              :name="item.value"
            >
              {{ item.label }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell>
        <van-cell-group v-if="data.tags&&data.tags.includes('112')">
          <van-field
            label="其他标签"
            :error= "errors.has('tagsOther')"
            v-model="data.tags_other" 
            placeholder="选择其他，请手填标签" 
            name="tagsOther"
            clearable
            v-validate="{ required: data.tags&&data.tags.includes('112') }" 
          />
        </van-cell-group>
    </div>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_2430000015604782",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>IoT付款申请单</em>，为<em>通用付款</em>申请,<span v-if="data.total_money1">申请金额为<em>{{data.total_money1 | money }}</em>（{{data.payment_currency_name}}），</span>请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="我方付款信息">
    <van-cell title="付款编号" v-model="data.payment_number"></van-cell>
    <van-cell title="付款名称" v-model="data.payment_summary"></van-cell>
    <van-cell title="付款币种" v-model="data.payment_currency_name"></van-cell>
    <van-cell title="支出类型" v-model="data.expense_type_name"></van-cell>
    <van-cell title="付款金额总计" v-if="data.total_money1">
        {{ data.total_money1| money}}
    </van-cell>
    <ax-fold>
        <van-cell title="RMB金额" v-model="data.local_amount" v-if="data.local_amount"></van-cell>
        <van-cell title="RMB金额大写" v-model="data.local_amount_words" v-if="data.local_amount_words"></van-cell>
        <van-cell title="付款单位" v-model="data.payment_company_name"></van-cell>
        <van-cell title="付款方式" v-model="data.payment_method_name"></van-cell>
        <van-cell v-if="data.cost_ratio !== ''" title="费用占比说明" v-model="data.cost_ratio"></van-cell>
        <van-cell title="是否预付款" v-model="data.is_payment_name"></van-cell>
        <van-cell title="付款情况摘要" v-model="data.payment_remark"></van-cell>
    </ax-fold>
</ax-panel>

<ax-panel title="合同信息">
    <van-cell title="关联合同">
        <router-link class="link_a" v-if="!data.contract_source_system || data.contract_source_system=='SSC'" :to="'/ssc/complete/details?instId='+data.contract_instid">
            {{data.contract_name}}
        </router-link>
        <a v-else  class="link_a"  target="blank" :href="$contract_baseurl+ '/ccrt/search/list?contractNumber='+ data.contract_code"> {{data.contract_name}}</a>  
    </van-cell>
    <van-cell title="合同金额" v-if="data.contract_amount1">
        {{ data.contract_amount1 | money }}
    </van-cell>
    <van-cell title="合同币种" v-if="data.contract_currency">
        {{ data.contract_currency }}
    </van-cell>
    <van-cell title="是否框架合同" v-if="data.is_framework_contract">
        {{ data.is_framework_contract }}
    </van-cell>
    <van-cell title="老OA合同编号" v-if="data.old_oa_contract_code">
        {{ data.old_oa_contract_code }}
    </van-cell>
    <van-cell title="付款里程碑" v-if="data.payment_contract_marker_name">
    {{ data.payment_contract_marker_name }}
    </van-cell>
</ax-panel>


<ax-panel title="预算信息" v-if="data.SUB_ap_payment_budget&&data.SUB_ap_payment_budget.length">
    <div v-for="(item, index) in data.SUB_ap_payment_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" v-model="item.budget_proj_name"></van-cell>
        <van-cell title="项目预算编码" v-model="item.budget_proj_name_code"></van-cell>
        <van-cell title="预算来源" v-model="item.budget_source"></van-cell>
        <van-cell title="预算使用情况" v-model="item.budget_source">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.budget_proj_name_code">查看</router-link>
        </van-cell>
        <van-cell title="剩余金额" v-if="item.surplus_amout">
            {{item.surplus_amout }}
        </van-cell>
        <van-cell title="预算使用金额" v-if="item.occupy_amount">
            {{item.occupy_amount | money}}
        </van-cell>
    </div>
</ax-panel>

<ax-panel title="业务信息">
    <van-cell title="IoT产品线">
        {{ data.IOTproduct_line_name }}
    </van-cell>
      <van-cell title="渠道类型">
        {{ data.channel_type_name }}
    </van-cell>
    <van-cell title="付款申请资料" v-if="isJSON(data.IOTpayment_data)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.IOTpayment_data)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
    <div v-if="data.expense_type === '23'">
        <van-cell title="是否订单类付款">
            {{ data.is_order_payment_name }}
        </van-cell>
        <div v-if="data.is_order_payment === '1'">
            <van-cell title="上传有效订单" v-if="isJSON(data.IOTeffective_order)">
                <ax-down v-for="(fileItem,index) in JSON.parse(data.IOTeffective_order)" type="ssc" :data="fileItem" :key="index"></ax-down>
            </van-cell>
        </div>
    </div>
</ax-panel>

<ax-panel title="对方收款信息">
    <div v-for="(item, index) in data.SUB_ap_payment_receipt" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="收款单位/人" v-model="item.company"></van-cell>
        <van-cell title="开户银行" v-model="item.open_bank_name"></van-cell>
        <van-cell title="支行银行名称" v-model="item.branch_bank_name"></van-cell>
        <van-cell title="收款银行账号" v-model="item.bank_account"></van-cell>
        <van-cell title="省" v-model="item.province"></van-cell>
        <van-cell title="市" v-model="item.city"></van-cell>
        <ax-fold>
            <van-cell title="预提编号" v-if="item.accrued_code_name">
                {{item.accrued_code_name}}
            </van-cell>
            <van-cell title="预提金额" v-if="item.accrued_money">
                {{item.accrued_money | money}}
            </van-cell>
            <van-cell title="金额">
                {{item.money_account | money}}
            </van-cell>
            <van-cell title="财务确认金额">
                {{item.fina_confir_amount | money}}
            </van-cell>
            <van-cell title="业务发生日期" v-model="item.actual_start_date"></van-cell>
            <van-cell title="业务编码" v-model="item.bussiness_code"></van-cell>
            <van-cell title="费用类型" v-model="item.expense_type_name"></van-cell>
            <van-cell title="项目类型" v-model="item.project_type_name"></van-cell>
            <van-cell title="一级渠道" v-model="item.one_channel_name"></van-cell>
            <van-cell title="二级渠道" v-model="item.two_channel_name"></van-cell>
            <van-cell title="三级渠道" v-model="item.three_channel_name"></van-cell>
            <van-cell title="产品线" v-model="item.product_line_name"></van-cell>
            <van-cell title="实际费用归属部门" v-model="item.expense_department_name"></van-cell>
            <van-cell v-if="item.org" title="OU名称" v-model="item.org_name"></van-cell>
            <van-cell v-if="item.invoice_number" title="AP发票" v-model="item.invoice_number"></van-cell>
            <van-cell v-if="item.item_desc !== ''" title="说明项" v-model="item.item_desc"></van-cell>
            <van-cell v-if="item.ept_payment_date" title="最后付款日期" v-model="item.ept_payment_date"></van-cell>
            <van-cell title="附件" v-if="isJSON(item.attachment)">
                <ax-down v-for="(fileItem,index) in JSON.parse(item.attachment)" type="ssc" :data="fileItem" :key="index"></ax-down>
            </van-cell>
        </ax-fold>
    </div>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_2430000015606143",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>实际付款申请单</em>，<span v-if="data.payment_cny_money">付款金额为<em>{{data.payment_cny_money | money }}</em>（{{data.payment_currency_name}}），</span>请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="付款信息">
    <van-cell title="所属付款编号" v-model="data.blone_ap_payment_number">
        <router-link class="link_a" :to="'/ssc/complete/details?instId='+data.blone_ap_payment_number_instid + '&appid='+ $route.query.appid+ '&version='+ $route.query.version">
            {{data.blone_ap_payment_number}}
        </router-link>
    </van-cell>
    <van-cell title="出纳付款编号" v-model="data.payment_number"></van-cell>
    <van-cell title="付款摘要" v-model="data.payment_summary"></van-cell>
    <van-cell title="付款单位" v-model="data.payment_company_name"></van-cell>
    <van-cell title="付款账号" v-model="data.pay_account"></van-cell>
    <ax-fold>
        <van-cell title="收款单位/人" v-model="data.company"></van-cell>
        <van-cell title="收款银行账号" v-model="data.bank_account"></van-cell>
        <van-cell title="开户银行" v-model="data.open_bank_name"></van-cell>
        <van-cell title="支行银行名称" v-model="data.branch_bank_name"></van-cell>
        <van-cell title="省" v-model="data.province"></van-cell>
        <van-cell title="市" v-model="data.city"></van-cell>
        <van-cell title="金额" v-model="data.money_account"></van-cell>
        <van-cell title="金额大写" v-model="data.money_words"></van-cell>
        <van-cell title="付款币种" v-model="data.payment_currency_name"></van-cell>
        <van-cell title="付款方式" v-model="data.payment_method_name"></van-cell>
        <van-cell v-if="data.payment_time" title="付款时间" v-model="data.payment_time"></van-cell>
        <van-cell title="支出类型" v-model="data.expense_type_name"></van-cell>
        <van-cell title="是否预付款" v-model="data.is_advance_payment"></van-cell>
        <van-cell title="发票类型" v-model="data.invoice_type_name"></van-cell>
    </ax-fold>
</ax-panel>
<ax-panel title="合同信息">
    <van-cell title="关联合同">
        <a  v-if="!data.contract_id && data.contract_code"  class="link_a"  target="blank" :href="$contract_baseurl+ '/ccrt/search/list?contractNumber='+ data.contract_code"> {{data.contract_name}}</a>   
        <router-link v-else class="link_a" :to="'/ssc/complete/details?instId='+data.contract_instid+ '&appid='+ $route.query.appid+ '&version='+ $route.query.version" replace="">
            {{data.contract_name}}
        </router-link>
    </van-cell>
    <van-cell title="合同金额" v-if="data.contract_amount1">
        {{ data.contract_amount1 | money }}
    </van-cell>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_ap_check_budget.length">
    <div v-for="(item, index) in data.SUB_ap_check_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称">{{item.budget_proj_name}}</van-cell>
        <van-cell title="剩余金额" v-if="item.surplus_amout">
            {{item.surplus_amout }}
        </van-cell>
        <van-cell title="实际占用金额">
            {{item.occupy_amount | money}}
        </van-cell>
        <van-cell title="预算使用情况">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.budget_proj_code">查看</router-link>
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="预提信息" v-if="data.SUB_ap_check_accrued.length">
    <div v-for="(item, index) in data.SUB_ap_check_accrued" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预提编号">
            {{item.accrued_code}}
        </van-cell>
        <van-cell title="占用金额">
            {{item.accrued_occupation_money | money}}
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_2430000017481364",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em v-if="data.framework==='0'">非框架</em><em v-else="">框架</em>商业化收入协议申请单，为<em>{{data.name}}</em>{{data.type_name}}，<span v-if="data.amount_adjust">申请金额为<em>{{data.amount_adjust | money}}</em>（{{data.currency_unit}}），</span>请您审批。            
            </p>
        </div>
        
    </ax-head>

<ax-panel title="协议属性">
    <van-cell title="合同类型" v-model="data.type_name"></van-cell>
    <van-cell title="合同语言" v-model="data.language_name"></van-cell>
    <van-cell title="关联原合同">
        <router-link class="link_a" :to="'/ssc/complete/details?instId='+data.source_inst_id">
            {{data.source_name}}
        </router-link>
    </van-cell>
</ax-panel>
<ax-panel title="协议信息">
    <div v-if="data.type_name!== '终止协议'">
        <van-cell title="协议名称" v-model="data.name"></van-cell>
        <van-cell title="协议期间" v-if="data.start">
            {{data.start}}至{{data.end}}
        </van-cell>
        <van-cell title="财务价格调整">
            {{data.price_adjust_name}}
        </van-cell>
        <van-cell title="调整金额" v-if="data.amount_adjust">
            {{data.amount_adjust | money}}
        </van-cell>
        <van-cell title="费用部门" v-model="data.cost_dept_name"></van-cell>
        <van-cell title="协议与主合同差异说明" v-model="data.difference"></van-cell>
    </div>
    <div v-else="">
        <van-cell title="协议名称" v-model="data.termination_name"></van-cell>
        <van-cell title="生效日期" v-if="data.termination_effective_date">
            {{data.termination_effective_date}}
        </van-cell>
        <van-cell title="协议说明" v-model="data.termination_desc"></van-cell>
    </div>
</ax-panel>
<ax-panel title="主体信息">
    <van-cell title="我方主体名称" v-model="data.our_companies_name"></van-cell>
    <van-cell class="top-item" title="对方主体："></van-cell>
    <div v-for="(item, index) in data.SUB_cm_contract_companies" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'主体'+(index+1)+'名称'" v-model="item.name"></van-cell>
        <van-cell title="是否关联方" v-model="item.is_rpt"></van-cell>
        <van-cell title="关联方申请单" v-if="item.is_rpt==='是'">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.rpt_inst_id">
                {{item.rpt_name}}
            </router-link>
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_cm_contract_budget.length">
    <div v-for="(item, index) in data.SUB_cm_contract_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" :value="item.business_name_name"></van-cell>
        <van-cell title="预算来源">{{item.source}}</van-cell>
        <van-cell title="预算使用金额">{{item.amount | money}}</van-cell>
        <van-cell title="预算使用情况">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.code">查看</router-link>
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index" ></ax-down>   
</ax-panel>

<ax-panel title="财务回填信息" v-if="permission.our_standard_template_form==='w'||permission.income_type_form==='w'">
    <van-cell title="是否我方标准模板" class="radio_box" :class="{ 'errors_box':errors.has('standard')}">
        <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <ax-select label="收入类型" v-model="data.income_type" :options="incomeValues" v-if="permission.income_type_form==='w'" :class="{ 'errors_box':errors.has('incomeType')}" v-validate="'required'" name="incomeType"></ax-select>
    <van-cell title="收入类型" v-if="permission.income_type_form!=='w'&&data.income_type_name" v-model="data.income_type_name"></van-cell>
</ax-panel>
<ax-panel title="法务回填信息" v-if="permission.tags_form==='w'||permission.important_form==='w'">
    <van-cell title="是否重大合同" class="radio_box" :class="{ 'errors_box':errors.has('important')}" v-if="permission.important_form==='w'">
        <van-radio-group v-model="data.important" v-validate="'required'" name="important">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <div v-if="permission.tags_form === 'w'">
        <van-cell title="选择合同标签" :class="{ 'errors_box':errors.has('tags')}">
          <van-checkbox-group v-model="data.tags" v-validate="'required'" name="tags">
            <van-checkbox
              v-for="(item, index) in incomeOptions"
              :key="index"
              :name="item.value"
            >
              {{ item.label }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell>
        <van-cell-group v-if="data.tags&&data.tags.includes('212')">
          <van-field
            label="其他标签"
            :error= "errors.has('tagsOther')"
            v-model="data.tags_other" 
            placeholder="选择其他，请手填标签" 
            name="tagsOther"
            clearable
            v-validate="{ required: data.tags&&data.tags.includes('212') }" 
          />
        </van-cell-group>
    </div>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_2430000019621067",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>外包人员VPN申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="相关信息">
        <van-cell title="接口人主管" :value="data.inner_manager"></van-cell>
        <van-cell title="接口人HR" v-model="data.inner_hr"></van-cell>
        <van-cell title="信息安全及权限提示">
            1、VPN系统是为了便于用户经Internet远程访问公司内部网络而设立，但由于用户客户端计算机的安全性不可控制，可能会影响内部网络安全，请慎重审批VPN使用权限。<br/>
 2、因员工泄露vpn密码与在不安全的客户端使用导致内网安全入侵，由员工本人及其审批上级承担责任。<br/>3、外包员工权限根据所在部门业务线分组，网络权限有所不同，如有特殊权限需求请访问：https://sec.corp.qihoo.net/ ,&lt;信息安全平台&gt;申请“VPN ACL”访问权限。<!--信息安全平台-->
        </van-cell>
        <van-cell title="申请原因" :value="data.reason"></van-cell>
</ax-panel>
<ax-panel title="明细信息">
    <div v-for="(item, index) in data.SUB_outsourcer_vpn_detail" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="关联外包人员账号申请" v-model="item.outsourcer_account_name"></van-cell>
        <van-cell title="外包人员姓名" v-model="item.outsourcer_name_name"></van-cell>
        <van-cell title="域账号" v-model="item.outsourcer_domain"></van-cell>
        <van-cell title="邮箱地址" v-model="item.outsourcer_mail"></van-cell>
        <van-cell title="TOKEN ID" :value="item.token_id"></van-cell>
        <van-cell title="外包公司名称" v-model="item.outsourcer_company"></van-cell>
        <van-cell title="合同编号" v-model="item.outsourcer_contract_code"></van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel> `
    ],
    [
        "MFM_4760000020242478",
        `
<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em><span v-if="data.category === '0'">资质/文件用章</span><span v-else="">资质/文件/章类借出借用</span>申请单</em>，请您审批。
        </p>
    </div>
</ax-head>

<ax-panel title="申请信息">
    <template >
        <van-cell title="来源系统" v-model="data.source_system_name"></van-cell>
        <van-cell title="来源系统编号" v-if="data.source_id" v-model="data.source_id"></van-cell>
    </template>
    <van-cell title="是否需要外借" v-model="data.is_need_borrow_name"></van-cell>
    <van-cell :title="data.category === '0'? '文件类型': '申请类型'" >
        {{data.second_classif_name}}
    </van-cell>
    
    <van-cell title="具体类型" v-if="data.specific_type" v-model="data.specific_type"></van-cell>
    <template v-if="data.category === '0'">
        <van-cell title="是否用印" v-model="data.is_use_seal_name"></van-cell>
        <van-cell title="用印类型" v-model="data.seal_category_name"></van-cell>
        <van-cell title="因公/因私" v-model="data.pub_or_pri_name" v-if="data.apply_type === 'qualification'&&data.pub_or_pri_name"></van-cell>
        <van-cell title="营业执照用途" :value="data.license_use" v-if="modelData.isShowLicenseUse"></van-cell>
        <van-cell title="开始时间"  v-if="data.start_date" v-model="data.start_date" ></van-cell>
        <van-cell title="结束时间" v-if="data.end_date"  v-model="data.end_date" ></van-cell>
    </template>
    <template v-if="data.category === '1'">
        <van-cell title="预计借出时间" v-model="data.start_date" ></van-cell>
        <van-cell title="预计归还时间" v-model="data.end_date" ></van-cell>
    </template>
    <van-cell title="公章/资质所属公司" v-model="data.company_name"></van-cell>
    <div class="">
        <div class="paddingl" style="font-size: 14px;line-height: 2;">对方主体:</div>
        <span class="ssc-tips paddingl">温馨提示：盖章文件提交的相对方名称</span> <br>
        <template v-for="(item, index) in data.SUB_opposite_subject ">
            <van-cell :class="{'top-item':index!==0}"  title="对方主体名称" v-model="item.oppsite_name"></van-cell>
            <van-cell title="风险主体" v-model="item.risk_company"></van-cell>
            <van-cell title="关联交易对象评估申请单" v-model="item.black_form"></van-cell>
        </template>
    </div>
    <van-cell  title="文件名称及使用目的" v-model="data.use_purpose"></van-cell>
    <van-cell title="上传文本" v-if="isJSON(data.attachment)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.attachment)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
    <van-cell title="电子版营业执照（带水印）" v-if="isJSON(data.license_scan)">
      <ax-down v-for="(fileItem,index) in JSON.parse(data.license_scan)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
    <van-cell title="备注" v-model="data.remarks"></van-cell>
</ax-panel>

<ax-panel title="人事信息"  v-if="data.project_name" >
    <van-cell title="项目名称"  v-model="data.project_name"></van-cell>
    <van-cell title="人事资料类型"  v-model="data.hr_file_type_name"></van-cell>
    <van-cell title="所需社保时间" v-if="data.social_time_name"   v-model="data.social_time_name"></van-cell>
    <van-cell title="涉及人数"  v-model="data.people_number"></van-cell>
    <van-cell title="职称名称"  v-if="data.title"  v-model="data.title"></van-cell>
    <van-cell title="技术资格内容" v-if="data.technical_content"  v-model="data.technical_content"></van-cell>
    <van-cell title="社保样例" >
        <router-link class="link_a"  to="/example/1" > 公司社保样例 </router-link>
        <router-link class="link_a"  to="/example/2" > 个人社保样例 </router-link>
    </van-cell>
    <van-cell title="固定人员信息"   v-if="data.fixed_person && data.fixed_person.length ">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.fixed_person)"  :class="{'top-item':index!==0}" type="ssc" :data="fileItem" :key="index" ></ax-down>   
    </van-cell>
    <van-cell title="其他附件"  v-if="data.other_file && data.other_file.length ">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.other_file)"  :class="{'top-item':index!==0}" type="ssc" :data="fileItem" :key="index" ></ax-down>   
    </van-cell>
</ax-panel>

<ax-panel title="法务回填信息" v-if="permission.approve_choose_form==='w'">
    <van-cell title="法务回填" :class="{ 'errors_box':errors.has('approveChoose')}">
      <van-checkbox-group v-model="modelData.approve_choose" v-validate="{ required: !modelData.none_approve }" name="approveChoose" :disabled="modelData.none_approve">
        <van-checkbox
          v-for="item in backfillValues"
          :key="item.value"
          :name="item.value"
        >
          {{ item.label }}
        </van-checkbox>
      </van-checkbox-group>
      <van-checkbox v-model="modelData.none_approve" @change="val => val && (modelData.approve_choose = [])">无需特殊审批</van-checkbox>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_4800000016331027",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>专用邮箱及邮件组申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="相关信息">
    <van-cell title="申请类型" v-model="data.apply_type_name"></van-cell>
    <van-cell title="邮箱名称" v-model="data.mail_address_name"></van-cell>
    <van-cell title="申请原因" v-model="data.apply_reason"></van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_110000002618101602",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em v-if="data.framework==='0'">非框架</em><em v-else="">框架</em>收入合同申请单，为<em>{{data.name}}</em>合同申请，申请金额为<em>{{data.amount | money}}</em>（{{data.currency_unit_name}}），请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="合同属性">
    <van-cell title="合同类型" v-model="data.type_name"></van-cell>
    <van-cell title="合同语言" v-model="data.language_name"></van-cell>
</ax-panel>
<ax-panel title="合同分类">
<van-cell title="合同分类" v-model="data.label_name"></van-cell>
<van-cell title="合同明细" v-model="data.sub_label_name"></van-cell>
</ax-panel>

<ax-panel title="合同信息">
    <van-cell title="合同名称" v-model="data.name"></van-cell>
    <div v-if="data.prepayments_name !=='否'">
        <van-cell title="合同期间" v-if="data.start&&data.end">
            {{data.start}}至{{data.end}}
        </van-cell>
    </div>
    <div v-else="">
        <van-cell title="合同起止日期">
            {{data.period_desc}}
        </van-cell>
    </div>
    <van-cell title="合同金额">
        {{data.amount | money}}
    </van-cell>
    <van-cell title="定价方式" v-model="data.pricing_method"></van-cell>
    <van-cell title="合同币种">
        {{data. currency_unit_name}}({{data.currency_unit}})
    </van-cell>
    <ax-fold>
        <van-cell title="是否预付款" v-model="data.prepayments_name"></van-cell>
        <van-cell title="费用部门" v-model="data.cost_dept_name"></van-cell>
        <van-cell title="合同内容摘要" v-model="data.summary"></van-cell>
    </ax-fold>
</ax-panel>

<ax-panel title="主体信息">
    <van-cell title="我方主体名称" v-model="data.our_companies_name"></van-cell>
    <van-cell class="top-item" title="对方主体："></van-cell>
    <div v-for="(item, index) in data.SUB_cm_contract_companies" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'主体'+(index+1)+'名称'" v-model="item.name"></van-cell>
        <van-cell title="是否关联方" v-model="item.is_rpt"></van-cell>
        <van-cell title="关联方申请单" v-if="item.is_rpt==='是'">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.rpt_inst_id">
                {{item.rpt_name}}
            </router-link>
        </van-cell>
        <van-cell title="风险主体" v-model="item.in_blacklist_name"></van-cell>
        <van-cell title="关联交易对象评估申请单" v-model="item.bcm_blacklist_flow_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_cm_contract_budget.length">
    <div v-for="(item, index) in data.SUB_cm_contract_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" v-model="item.business_name_name"></van-cell>
        <van-cell title="预算使用金额">
            {{item.amount | money}}
        </van-cell>
    </div>
</ax-panel>

<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index" ></ax-down>   
</ax-panel>

<ax-panel title="相关协议" v-if="agreementList&&agreementList.length">
    <div v-for="(item,index) in agreementList">
        <van-cell :class="{'top-item':index!==0}" title="协议编号" v-model="data.code"></van-cell>
        <van-cell title="协议名称" v-model="item.retirement_type_name">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.instId">
                {{item.name}}
            </router-link>
        </van-cell>
        <van-cell title="协议类型" v-model="item.typeName"></van-cell>
    </div>
</ax-panel>

<ax-panel title="财务回填信息" v-if="permission.our_standard_template_form==='w'||permission.income_type_form==='w'">
    <van-cell title="是否我方标准模板" class="radio_box" :class="{ 'errors_box':errors.has('standard')}">
        <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <ax-select label="收入类型" v-model="data.income_type" :options="incomeValues" v-if="permission.income_type_form==='w'" :class="{ 'errors_box':errors.has('incomeType')}" v-validate="'required'" name="incomeType"></ax-select>
    <van-cell title="收入类型" v-if="permission.income_type_form!=='w'&&data.income_type_name" v-model="data.income_type_name"></van-cell>
</ax-panel>
<ax-panel title="法务回填信息" v-if="permission.tags_form==='w'||permission.important_form==='w'">
    <van-cell title="是否重大合同" class="radio_box" :class="{ 'errors_box':errors.has('important')}" v-if="permission.important_form==='w'">
        <van-radio-group v-model="data.important" v-validate="'required'" name="important">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <div v-if="permission.tags_form === 'w'">
        <van-cell title="选择合同标签" :class="{ 'errors_box':errors.has('tags')}">
          <van-checkbox-group v-model="data.tags" v-validate="'required'" name="tags">
            <van-checkbox
              v-for="(item, index) in incomeOptions"
              :key="index"
              :name="item.value"
            >
              {{ item.label }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell>
        <van-cell-group v-if="data.tags&&data.tags.includes('212')">
          <van-field
            label="其他标签"
            :error= "errors.has('tagsOther')"
            v-model="data.tags_other" 
            placeholder="选择其他，请手填标签" 
            name="tagsOther"
            clearable
            v-validate="{ required: data.tags&&data.tags.includes('212') }" 
          />
        </van-cell-group>
    </div>
</ax-panel>

<ax-panel title="审批信息" v-if="bpmTask.name==='财务三审（子公司）'">
    <van-cell title="是否重大事项" class="radio_box" :class="{ 'errors_box':errors.has('isMajor')}" >
        <van-radio-group v-model="data.is_major" v-validate="'required'" name="isMajor">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_110000002618101603",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em v-if="data.framework==='0'">非框架</em><em v-else="">框架</em>免费合同申请单，为<em>{{data.name}}</em>合同申请，请您审批。           
        </p>
    </div>
</ax-head>

<ax-panel title="合同属性">
    <van-cell title="合同类型" v-model="data.type_name"></van-cell>
    <van-cell title="合同语言" v-model="data.language_name"></van-cell>
</ax-panel>
<ax-panel title="合同分类">
<van-cell title="合同分类" v-model="data.label_name"></van-cell>
<van-cell title="合同明细" v-model="data.sub_label_name"></van-cell>
</ax-panel>
<ax-panel title="合同信息">
    <van-cell title="合同名称" v-model="data.name"></van-cell>
    <van-cell title="合同期间" v-if="data.start&&data.end">
        {{data.start}}至{{data.end}}
    </van-cell>
    <van-cell title="合同内容摘要" v-model="data.summary"></van-cell>
</ax-panel>

<ax-panel title="主体信息">
    <van-cell title="我方主体名称" v-model="data.our_companies_name"></van-cell>
    <van-cell class="top-item" title="对方主体："></van-cell>
    <div v-for="(item, index) in data.SUB_cm_contract_companies" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'主体'+(index+1)+'名称'" v-model="item.name"></van-cell>
        <van-cell title="是否关联方" v-model="item.is_rpt"></van-cell>
        <van-cell title="关联方申请单" v-if="item.is_rpt==='是'">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.rpt_inst_id">
                {{item.rpt_name}}
            </router-link>
        </van-cell>
        <van-cell title="风险主体" v-model="item.in_blacklist_name"></van-cell>
        <van-cell title="关联交易对象评估申请单" v-model="item.bcm_blacklist_flow_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_cm_contract_budget.length">
    <div v-for="(item, index) in data.SUB_cm_contract_budget" :key="index">
        <van-cell class="top-item" title="预算项目名称" v-model="item.business_name_name"></van-cell>
        <van-cell title="预算使用金额">
            {{item.amount | money}}
        </van-cell>
    </div>
</ax-panel>

<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index" ></ax-down>    
</ax-panel>

<ax-panel title="相关协议" v-if="agreementList.length">
    <div v-for="(item,index) in agreementList">
        <van-cell :class="{'top-item':index!==0}" title="协议编号" v-model="data.code"></van-cell>
        <van-cell title="协议名称" v-model="item.retirement_type_name">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.instId">
                {{item.name}}
            </router-link>
        </van-cell>
        <van-cell title="协议类型" v-model="item.typeName"></van-cell>
    </div>
</ax-panel>

<ax-panel title="相关协议" v-if="agreementList.length">
    <div v-for="(item,index) in agreementList">
        <van-cell :class="{'top-item':index!==0}" title="协议编号" v-model="data.code"></van-cell>
        <van-cell title="协议名称" v-model="item.retirement_type_name">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.instId">
                {{item.name}}
            </router-link>
        </van-cell>
        <van-cell title="协议类型" v-model="item.typeName"></van-cell>
    </div>
</ax-panel>

<ax-panel title="财务回填信息" v-if="permission.our_standard_template_form==='w'||permission.income_type_form==='w'">
    <van-cell title="是否我方标准模板" class="radio_box" :class="{ 'errors_box':errors.has('standard')}">
        <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <ax-select label="收入类型" v-model="data.income_type" :options="incomeValues" v-if="permission.income_type_form==='w'" :class="{ 'errors_box':errors.has('incomeType')}" v-validate="'required'" name="incomeType"></ax-select>
    <van-cell title="收入类型" v-if="permission.income_type_form!=='w'&&data.income_type_name" v-model="data.income_type_name"></van-cell>
</ax-panel>
<ax-panel title="法务回填信息" v-if="permission.tags_form==='w'||permission.important_form==='w'">
    <van-cell title="是否重大合同" class="radio_box" :class="{ 'errors_box':errors.has('important')}" v-if="permission.important_form==='w'">
        <van-radio-group v-model="data.important" v-validate="'required'" name="important">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <div v-if="permission.tags_form === 'w'">
        <van-cell title="选择合同标签" :class="{ 'errors_box':errors.has('tags')}">
          <van-checkbox-group v-model="data.tags" v-validate="'required'" name="tags">
            <van-checkbox
              v-for="(item, index) in freeOptions"
              :key="index"
              :name="item.value"
            >
              {{ item.label }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell>
        <van-cell-group v-if="data.tags&&data.tags.includes('309')">
          <van-field
            label="其他标签"
            :error= "errors.has('tagsOther')"
            v-model="data.tags_other" 
            placeholder="选择其他，请手填标签" 
            name="tagsOther"
            clearable
            v-validate="{ required: data.tags&&data.tags.includes('309') }" 
          />
        </van-cell-group>
    </div>
</ax-panel>

<ax-panel title="审批信息" v-if="bpmTask.name==='财务三审（子公司）'">
    <van-cell title="是否重大事项" class="radio_box" :class="{ 'errors_box':errors.has('isMajor')}" >
        <van-radio-group v-model="data.is_major" v-validate="'required'" name="isMajor">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_110000002882205902",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em v-if="data.framework==='0'">非框架</em><em v-else="">框架</em>支出合同协议申请单，为<em>{{data.name}}</em>{{data.type_name}}，<span v-if="data.amount_adjust">申请金额为<em>{{data.amount_adjust | money}}</em>（{{data.currency_unit}}），</span>请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="协议属性">
    <van-cell title="合同类型" v-model="data.type_name"></van-cell>
    <van-cell title="合同语言" v-model="data.language_name"></van-cell>
    
    <van-cell title="合同分类" v-model="data.label_name"></van-cell>
    <van-cell title="合同明细" v-model="data.sub_label_name"></van-cell>

    <van-cell title="关联原合同">
        <router-link class="link_a" :to="'/ssc/complete/details?instId='+data.source_inst_id">
            {{data.source_name}}
        </router-link>
    </van-cell>
</ax-panel>
<ax-panel title="协议信息">
    <div v-if="data.type_name!== '终止协议'">
        <van-cell title="协议名称" v-model="data.name"></van-cell>
        <van-cell title="协议期间" v-if="data.start">
            {{data.start}}至{{data.end}}
        </van-cell>
        <van-cell title="财务价格调整">
            {{data.price_adjust_name}}
        </van-cell>
        <van-cell title="调整金额" v-if="data.amount_adjust">
            {{data.amount_adjust | money}}
        </van-cell>
        <van-cell title="费用部门" v-model="data.cost_dept_name"></van-cell>
        <van-cell title="协议与主合同差异说明" v-model="data.difference"></van-cell>
    </div>
    <div v-else="">
        <van-cell title="协议名称" v-model="data.termination_name"></van-cell>
        <van-cell title="生效日期" v-if="data.termination_effective_date">
            {{data.termination_effective_date}}
        </van-cell>
        <van-cell title="协议说明" v-model="data.termination_desc"></van-cell>
    </div>
</ax-panel>
<ax-panel title="主体信息">
    <van-cell title="我方主体名称" v-model="data.our_companies_name"></van-cell>
    <van-cell class="top-item" title="对方主体："></van-cell>
    <div v-for="(item, index) in data.SUB_cm_contract_companies" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'主体'+(index+1)+'名称'" v-model="item.name"></van-cell>
        <van-cell title="是否关联方" v-model="item.is_rpt"></van-cell>
        <van-cell title="关联方申请单" v-if="item.is_rpt==='是'">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.rpt_inst_id">
                {{item.rpt_name}}
            </router-link>
        </van-cell>
        <van-cell title="风险主体" v-model="item.in_blacklist_name"></van-cell>
        <van-cell title="关联交易对象评估申请单" v-model="item.bcm_blacklist_flow_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_cm_contract_budget.length">
    <div v-for="(item, index) in data.SUB_cm_contract_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" :value="item.business_name_name"></van-cell>
        <van-cell title="预算来源">{{item.source}}</van-cell>
        <van-cell title="预算使用金额">{{item.amount | money}}</van-cell>
        <van-cell title="预算使用情况">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.code">查看详情</router-link>
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index" ></ax-down>     
</ax-panel>

<ax-panel title="财务回填信息" v-if="permission.our_standard_template_form==='w'">
    <van-cell title="是否我方标准模板" class="radio_box" :class="{ 'errors_box':errors.has('standard')}">
        <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>
<ax-panel title="法务回填信息" v-if="permission.tags_form==='w'||permission.important_form==='w'">
    <van-cell title="是否重大合同" class="radio_box" :class="{ 'errors_box':errors.has('important')}" v-if="permission.important_form==='w'">
        <van-radio-group v-model="data.important" v-validate="'required'" name="important">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <div v-if="permission.tags_form === 'w'">
        <van-cell title="选择合同标签" :class="{ 'errors_box':errors.has('tags')}">
          <van-checkbox-group v-model="data.tags" v-validate="'required'" name="tags">
            <van-checkbox
              v-for="(item, index) in expOptions"
              :key="index"
              :name="item.value"
            >
              {{ item.label }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell>
        <van-cell-group v-if="data.tags&&data.tags.includes('112')">
          <van-field
            label="其他标签"
            :error= "errors.has('tagsOther')"
            v-model="data.tags_other" 
            placeholder="选择其他，请手填标签" 
            name="tagsOther"
            clearable
            v-validate="{ required: data.tags&&data.tags.includes('112') }" 
          />
        </van-cell-group>
    </div>
</ax-panel>

<ax-panel title="审批信息" v-if="bpmTask.name==='财务三审（子公司）'">
    <van-cell title="是否重大事项" class="radio_box" :class="{ 'errors_box':errors.has('isMajor')}" >
        <van-radio-group v-model="data.is_major" v-validate="'required'" name="isMajor">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_110000002882205903",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em v-if="data.framework==='0'">非框架</em><em v-else="">框架</em>收入合同申请单，为<em>{{data.name}}</em>{{data.type_name}}，<span v-if="data.amount_adjust">申请金额为<em>{{data.amount_adjust | money}}</em>（{{data.currency_unit}}），</span>请您审批。            
            </p>
        </div>
        
    </ax-head>

<ax-panel title="协议属性">
    <van-cell title="合同类型" v-model="data.type_name"></van-cell>
    <van-cell title="合同语言" v-model="data.language_name"></van-cell>
    
    <van-cell title="合同分类" v-model="data.label_name"></van-cell>
    <van-cell title="合同明细" v-model="data.sub_label_name"></van-cell>

    <van-cell title="关联原合同">
        <router-link class="link_a" :to="'/ssc/complete/details?instId='+data.source_inst_id">
            {{data.source_name}}
        </router-link>
    </van-cell>
</ax-panel>
<ax-panel title="协议信息">
    <div v-if="data.type_name!== '终止协议'">
        <van-cell title="协议名称" v-model="data.name"></van-cell>
        <van-cell title="协议期间" v-if="data.start">
            {{data.start}}至{{data.end}}
        </van-cell>
        <van-cell title="财务价格调整">
            {{data.price_adjust_name}}
        </van-cell>
        <van-cell title="调整金额" v-if="data.amount_adjust">
            {{data.amount_adjust | money}}
        </van-cell>
        <van-cell title="费用部门" v-model="data.cost_dept_name"></van-cell>
        <van-cell title="协议与主合同差异说明" v-model="data.difference"></van-cell>
    </div>
    <div v-else="">
        <van-cell class="top-item" title="协议名称" v-model="data.termination_name"></van-cell>
        <van-cell title="生效日期" v-if="data.termination_effective_date">
            {{data.termination_effective_date}}
        </van-cell>
        <van-cell title="协议说明" v-model="data.termination_desc"></van-cell>
    </div>
</ax-panel>
<ax-panel title="主体信息">
    <van-cell title="我方主体名称" v-model="data.our_companies_name"></van-cell>
    <van-cell class="top-item" title="对方主体："></van-cell>
    <div v-for="(item, index) in data.SUB_cm_contract_companies" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'主体'+(index+1)+'名称'" v-model="item.name"></van-cell>
        <van-cell title="是否关联方" v-model="item.is_rpt"></van-cell>
        <van-cell title="关联方申请单" v-if="item.is_rpt==='是'">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.rpt_inst_id">
                {{item.rpt_name}}
            </router-link>
        </van-cell>
        <van-cell title="风险主体" v-model="item.in_blacklist_name"></van-cell>
        <van-cell title="关联交易对象评估申请单" v-model="item.bcm_blacklist_flow_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_cm_contract_budget.length">
    <div v-for="(item, index) in data.SUB_cm_contract_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" :value="item.business_name_name"></van-cell>
        <van-cell title="预算来源">{{item.source}}</van-cell>
        <van-cell title="预算使用金额">{{item.amount | money}}</van-cell>
        <van-cell title="预算使用情况">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.code">查看</router-link>
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index" ></ax-down>   
</ax-panel>

<ax-panel title="财务回填信息" v-if="permission.our_standard_template_form==='w'||permission.income_type_form==='w'">
    <van-cell title="是否我方标准模板" class="radio_box" :class="{ 'errors_box':errors.has('standard')}">
        <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <ax-select label="收入类型" v-model="data.income_type" :options="incomeValues" v-if="permission.income_type_form==='w'" :class="{ 'errors_box':errors.has('incomeType')}" v-validate="'required'" name="incomeType"></ax-select>
    <van-cell title="收入类型" v-if="permission.income_type_form!=='w'&&data.income_type_name" v-model="data.income_type_name"></van-cell>
</ax-panel>
<ax-panel title="法务回填信息" v-if="permission.tags_form==='w'||permission.important_form==='w'">
    <van-cell title="是否重大合同" class="radio_box" :class="{ 'errors_box':errors.has('important')}" v-if="permission.important_form==='w'">
        <van-radio-group v-model="data.important" v-validate="'required'" name="important">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <div v-if="permission.tags_form === 'w'">
        <van-cell title="选择合同标签" :class="{ 'errors_box':errors.has('tags')}">
          <van-checkbox-group v-model="data.tags" v-validate="'required'" name="tags">
            <van-checkbox
              v-for="(item, index) in incomeOptions"
              :key="index"
              :name="item.value"
            >
              {{ item.label }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell>
        <van-cell-group v-if="data.tags&&data.tags.includes('212')">
          <van-field
            label="其他标签"
            :error= "errors.has('tagsOther')"
            v-model="data.tags_other" 
            placeholder="选择其他，请手填标签" 
            name="tagsOther"
            clearable
            v-validate="{ required: data.tags&&data.tags.includes('212') }" 
          />
        </van-cell-group>
    </div>
</ax-panel>

<ax-panel title="审批信息" v-if="bpmTask.name==='财务三审（子公司）'">
    <van-cell title="是否重大事项" class="radio_box" :class="{ 'errors_box':errors.has('isMajor')}" >
        <van-radio-group v-model="data.is_major" v-validate="'required'" name="isMajor">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_243000001743175505",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em v-if="data.framework==='0'">非框架</em><em v-else="">框架</em>商业化收入合同申请单，为<em>{{data.name}}</em>合同申请，申请金额为<em>{{data.amount | money}}</em>（{{data.currency_unit_name}}），请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="合同属性">
    <van-cell title="合同类型" v-model="data.type_name"></van-cell>
    <van-cell title="合同语言" v-model="data.language_name"></van-cell>
</ax-panel>
<ax-panel title="合同分类">
<van-cell title="合同分类" v-model="data.label_name"></van-cell>
<van-cell title="合同明细" v-model="data.sub_label_name"></van-cell>
</ax-panel>
<ax-panel title="合同信息">
    <van-cell title="合同名称" v-model="data.name"></van-cell>
    <div v-if="data.prepayments_name !=='否'">
        <van-cell title="合同期间" v-if="data.start&&data.end">
            {{data.start}}至{{data.end}}
        </van-cell>
    </div>
    <div v-else="">
        <van-cell title="合同起止日期">
            {{data.period_desc}}
        </van-cell>
    </div>
    <van-cell title="合同金额">
        {{data.amount | money}}
    </van-cell>
    <van-cell title="定价方式" v-model="data.pricing_method"></van-cell>
    <van-cell title="合同币种">
        {{data. currency_unit_name}}({{data.currency_unit}})
    </van-cell>
    <ax-fold>
        <van-cell title="是否预付款" v-model="data.prepayments_name"></van-cell>
        <van-cell title="费用部门" v-model="data.cost_dept_name"></van-cell>
        <van-cell title="业务类型" v-model="data.business_type_name"></van-cell>
        <van-cell v-if="data.advertisers&&data.advertisers!==''" title="广告主名称" v-model="data.advertisers"></van-cell>
        <van-cell title="合同内容摘要" v-model="data.summary"></van-cell>
    </ax-fold>
</ax-panel>

<ax-panel title="主体信息">
    <van-cell title="我方主体名称" v-model="data.our_companies_name"></van-cell>
    <van-cell class="top-item" title="对方主体："></van-cell>
    <div v-for="(item, index) in data.SUB_cm_contract_companies" :key="index">
        <van-cell :class="{'top-item':index!==0}" :title="'主体'+(index+1)+'名称'" v-model="item.name"></van-cell>
        <van-cell title="是否关联方" v-model="item.is_rpt"></van-cell>
        <van-cell title="关联方申请单" v-if="item.is_rpt==='是'">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.rpt_inst_id">
                {{item.rpt_name}}
            </router-link>
        </van-cell>
        <van-cell title="风险主体" v-model="item.in_blacklist_name"></van-cell>
        <van-cell title="关联交易对象评估申请单" v-model="item.bcm_blacklist_flow_name"></van-cell>
    </div>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_cm_contract_budget.length">
    <div v-for="(item, index) in data.SUB_cm_contract_budget" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" v-model="item.business_name_name"></van-cell>
        <van-cell title="预算使用金额">
            {{item.amount | money}}
        </van-cell>
    </div>
</ax-panel>

<ax-panel title="合同文本" v-if="isJSON(data.files)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.files)" type="ssc" :data="fileItem" :key="index" ></ax-down>     
</ax-panel>

<ax-panel title="相关协议" v-if="agreementList.length">
    <div v-for="(item,index) in agreementList">
        <van-cell :class="{'top-item':index!==0}" title="协议编号" v-model="data.code"></van-cell>
        <van-cell title="协议名称" v-model="item.retirement_type_name">
            <router-link class="link_a" :to="'/ssc/complete/details?instId='+item.instId">
                {{item.name}}
            </router-link>
        </van-cell>
        <van-cell title="协议类型" v-model="item.typeName"></van-cell>
    </div>
</ax-panel>

<ax-panel title="财务回填信息" v-if="permission.our_standard_template_form==='w'||permission.income_type_form==='w'">
    <van-cell title="是否我方标准模板" class="radio_box" :class="{ 'errors_box':errors.has('standard')}">
        <van-radio-group v-model="data.our_standard_template" v-validate="'required'" name="standard">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <ax-select label="收入类型" v-model="data.income_type" :options="incomeValues" v-if="permission.income_type_form==='w'" :class="{ 'errors_box':errors.has('incomeType')}" v-validate="'required'" name="incomeType"></ax-select>
    <van-cell title="收入类型" v-if="permission.income_type_form!=='w'&&data.income_type_name" v-model="data.income_type_name"></van-cell>
</ax-panel>
<ax-panel title="法务回填信息" v-if="permission.tags_form==='w'||permission.important_form==='w'">
    <van-cell title="是否重大合同" class="radio_box" :class="{ 'errors_box':errors.has('important')}" v-if="permission.important_form==='w'">
        <van-radio-group v-model="data.important" v-validate="'required'" name="important">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
    <div v-if="permission.tags_form === 'w'">
        <van-cell title="选择合同标签" :class="{ 'errors_box':errors.has('tags')}">
          <van-checkbox-group v-model="data.tags" v-validate="'required'" name="tags">
            <van-checkbox
              v-for="(item, index) in incomeOptions"
              :key="index"
              :name="item.value"
            >
              {{ item.label }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell>
        <van-cell-group v-if="data.tags&&data.tags.includes('212')">
          <van-field
            label="其他标签"
            :error= "errors.has('tagsOther')"
            v-model="data.tags_other" 
            placeholder="选择其他，请手填标签" 
            name="tagsOther"
            clearable
            v-validate="{ required: data.tags&&data.tags.includes('212') }" 
          />
        </van-cell-group>
    </div>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_243000001788167602",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>无预算付款申请单</em>，<span v-if="data.total_money1">申请金额为<em>{{data.total_money1 | money }}</em>（{{data.payment_currency_name}}），</span>请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="我方付款信息">
    <van-cell title="付款编号" v-model="data.payment_number"></van-cell>
    <van-cell title="付款名称" v-model="data.payment_summary"></van-cell>
    <van-cell title="付款币种" v-model="data.payment_currency_name"></van-cell>
    <van-cell title="支出类型" v-model="data.expense_type_name"></van-cell>
    <van-cell title="付款金额总计">
        {{ data.total_money1| money}}
    </van-cell>
    <van-cell title="RMB金额" v-model="data.local_amount" v-if="data.local_amount"></van-cell>
    <van-cell title="RMB金额大写" v-model="data.local_amount_words" v-if="data.local_amount_words"></van-cell>
    <van-cell title="付款单位" v-model="data.payment_company_name"></van-cell>
    <van-cell title="付款方式" v-model="data.payment_method_name"></van-cell>
    <van-cell v-if="data.cost_ratio !== ''" title="费用占比说明" v-model="data.cost_ratio"></van-cell>
    <van-cell title="是否预付款" v-model="data.is_payment_name"></van-cell>
    <van-cell title="付款情况摘要" v-model="data.payment_remark"></van-cell>
</ax-panel>
<ax-panel title="合同信息">
    <van-cell title="关联合同">
        <router-link class="link_a" v-if="!data.contract_source_system || data.contract_source_system=='SSC'" :to="'/ssc/complete/details?instId='+data.contract_instid">
            {{data.contract_name}}
        </router-link>
        <a v-else  class="link_a"  target="blank" :href="$contract_baseurl+ '/ccrt/search/list?contractNumber='+ data.contract_code"> {{data.contract_name}}</a>   
    </van-cell>
    <van-cell title="合同金额" v-if="data.contract_amount">
        {{ data.contract_amount | money }}
    </van-cell>
    <van-cell title="合同币种">
        {{ data.contract_currency }}
    </van-cell>
    <van-cell title="是否框架合同">
        {{ data.is_framework_contract }}
    </van-cell>
</ax-panel>
<ax-panel title="对方收款信息" v-if="data.SUB_ap_payment_receipt.length">
    <div v-for="(item, index) in data.SUB_ap_payment_receipt" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="收款单位/人" v-model="item.company"></van-cell>
        <van-cell title="开户银行" v-model="item.open_bank_name"></van-cell>
        <van-cell title="支行银行名称" v-model="item.branch_bank_name"></van-cell>
        <van-cell title="收款银行账号" v-model="item.bank_account"></van-cell>
        <van-cell title="省" v-model="item.province"></van-cell>
        <van-cell title="市" v-model="item.city"></van-cell>
        <ax-fold>
            <van-cell title="预提编号" v-if="item.accrued_code_name">
                {{item.accrued_code_name}}
            </van-cell>
            <van-cell title="预提金额" v-if="item.accrued_money">
                {{item.accrued_money | money}}
            </van-cell>
            <van-cell title="金额">
                {{item.money_account | money}}
            </van-cell>
            <van-cell title="财务确认金额">
                {{item.fina_confir_amount | money}}
            </van-cell>
            <van-cell title="业务发生日期" v-model="item.actual_start_date"></van-cell>
            <van-cell title="业务编码" v-model="item.bussiness_code"></van-cell>
            <van-cell title="费用类型" v-model="item.expense_type_name"></van-cell>
            <van-cell title="项目类型" v-model="item.project_type_name"></van-cell>
            <van-cell title="实际费用归属部门" v-model="item.expense_department_name"></van-cell>
            <van-cell v-if="item.org" title="OU名称" v-model="item.org_name"></van-cell>
            <van-cell v-if="item.invoice_number" title="AP发票" v-model="item.invoice_number"></van-cell>
            <van-cell v-if="item.item_desc&&item.item_desc !== ''" title="说明项" v-model="item.item_desc"></van-cell>
            <van-cell v-if="item.ept_payment_date" title="最后付款日期" v-model="item.ept_payment_date"></van-cell>
            <van-cell title="附件" v-if="isJSON(item.attachment)">
                <ax-down v-for="(fileItem,index) in JSON.parse(item.attachment)" type="ssc" :data="fileItem" :key="index" ></ax-down>
            </van-cell>
        </ax-fold>
    </div>
</ax-panel>

<ax-panel title="审批信息" v-if="bpmTask.name==='财务三审（子公司）'">
    <van-cell title="是否重大事项" class="radio_box" :class="{ 'errors_box':errors.has('isMajor')}" >
        <van-radio-group v-model="data.is_major" v-validate="'required'" name="isMajor">
            <van-radio v-for="(item, index) in whetherOptions" :key="index" :name="item.value">
                {{item.label}}
            </van-radio>
        </van-radio-group>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000017290286",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>IT设备赔偿申请单</em>，请您审批。
        </p>
    </div>
</ax-head>
<ax-panel title="标题">
    <van-cell title="丢失日期" v-model="data.lost_date"></van-cell>
    <van-cell title="编号" v-model="data.apply_code"></van-cell>
    <van-cell title="丢失说明" v-model="data.lost_desc"></van-cell>
</ax-panel>
<ax-panel title="申请说明">
    <van-cell class="des-cell paddingl">
        注：因为本人的原因造成公司固定资产丢失，我将在公司指定日期之前自行前往财务交还相应补偿款，若超过期限未能主动归还，我同意公司从我的工资中进行税后扣款。
    </van-cell>
    <van-cell class="des-cell paddingl">
        若在办理离职手续期间发现因我本人原因造成的固定资产丢失情况，我承诺会在最后工作日之前完成补偿款缴纳，否则，我同意公司从我的工资中进行税后扣款。
    </van-cell>
    <van-cell>
        {{data.declare_name}}
    </van-cell>
</ax-panel>
<ax-panel title="丢失设备信息" v-if="data.SUB_itdb_compensate_backup.length">
    <div v-for="(item,index) in data.SUB_itdb_compensate_backup" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="固定资产号" v-model="item.fixed_asset_no_name"></van-cell>
        <van-cell title="资产类别" v-model="item.asset_category"></van-cell>
        <van-cell title="品牌" v-model="item.brand"></van-cell>
        <van-cell title="PO编号" v-model="item.po_number"></van-cell>
        <van-cell title="资产型号" v-model="item.asset_model"></van-cell>
        <van-cell title="领用责任人" v-model="item.owner"></van-cell>
        <ax-fold>
            <van-cell title="SN号" v-model="item.sn_no"></van-cell>
            <van-cell v-if="item.purchase_subject_name&&item.purchase_subject_name!==''" title="采购主体" v-model="item.purchase_subject_name"></van-cell>
            <van-cell v-if="item.purchase_money&&item.purchase_money!==''" title="采购金额" v-model="item.purchase_money"></van-cell>
            <van-cell v-if="item.purchase_date&&item.purchase_date!==''" title="采购日期" v-model="item.purchase_date"></van-cell>
            <van-cell v-if="item.current_value&&item.current_value!==''" title="目前市场值" v-model="item.current_value"></van-cell>
            <van-cell v-if="item.scrap_value&&item.scrap_value!==''" title="设备残值" v-model="item.scrap_value"></van-cell>
            <van-cell v-if="item.compensate_money&&item.compensate_money!==''" title="赔偿金额" v-model="item.compensate_money"></van-cell>
        </ax-fold>
    </div>
</ax-panel>
<ax-panel title="其他设备信息" v-if="data.SUB_itdb_compensate_other.length">
    <div v-for="(item,index) in data.SUB_itdb_compensate_other" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="固定资产号" v-model="item.fixed_asset_no"></van-cell>
        <van-cell title="资产类别" v-model="item.asset_category"></van-cell>
        <van-cell title="品牌" v-model="item.brand"></van-cell>
        <van-cell title="资产型号" v-model="item.asset_model"></van-cell>
        <van-cell title="领用责任人" v-model="item.owner"></van-cell>
        <ax-fold>
            <van-cell title="SN号" v-model="item.sn_no"></van-cell>
            <van-cell v-if="item.purchase_subject_name&&item.purchase_subject_name!==''" title="采购主体" v-model="item.purchase_subject_name"></van-cell>
            <van-cell v-if="item.purchase_money&&item.purchase_money!==''" title="采购金额" v-model="item.purchase_money"></van-cell>
            <van-cell v-if="item.purchase_date&&item.purchase_date!==''" title="采购日期" v-model="item.purchase_date"></van-cell>
            <van-cell v-if="item.current_value&&item.current_value!==''" title="目前市场值" v-model="item.current_value"></van-cell>
            <van-cell v-if="item.scrap_value&&item.scrap_value!==''" title="设备残值" v-model="item.scrap_value"></van-cell>
            <van-cell v-if="item.compensate_money&&item.compensate_money!==''" title="赔偿金额" v-model="item.compensate_money"></van-cell>
        </ax-fold>
    </div>
</ax-panel>
<ax-panel title="交款信息">
    <van-cell title="最迟赔偿日期">
        <p>
            {{data.compensate_date}} <span style="color: #e6a800;">赔偿金请交到A座8层出纳团队；自动算给规则到节点之后计算</span>
        </p>
    </van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000015651327",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>IT测试设备申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>

<ax-panel title="表头类型">
    <van-cell title="申请单编号" v-model="data.code"></van-cell>
    <van-cell title="费用部门" v-model="data.cost_dept_name"></van-cell>
    <van-cell title="申请测试类设备目的，原因简述" v-model="data.reason"></van-cell>
</ax-panel>
<ax-panel title="申请测试类设备明细" v-if="data.SUB_itdb_test_detail.length">
    <div v-for="(item,index) in data.SUB_itdb_test_detail" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="类型" v-model="item.category_name"></van-cell>
        <van-cell title="品牌" v-model="item.brand"></van-cell>
        <van-cell title="型号" v-model="item.model"></van-cell>
        <van-cell title="配置" v-model="item.config"></van-cell>
        <van-cell title="数量" v-model="item.quantity"></van-cell>
        <van-cell title="单价(人民币)">
            {{item.price | money}}
        </van-cell>
        <van-cell title="金额(人民币)">
            {{item.price*item.quantity | money}}
        </van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000016127097",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的IT设备维修申请单，请您审批。
            </p>
        </div>
        
    </ax-head>
<ax-panel title="基础信息">
    <van-cell title="设备类型" v-model="data.type_name"></van-cell>
    <van-cell title="检测/维修工程师" v-model="data.engineer_name"></van-cell>
</ax-panel>
<ax-panel title="设备信息" v-if="data.SUB_itdb_repair_detail.length">
    <div v-for="(item,index) in data.SUB_itdb_repair_detail" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="资产类型" v-model="item.type_name"></van-cell>
        <van-cell title="品牌" v-model="item.brand"></van-cell>
        <van-cell title="资产型号" v-model="item.model"></van-cell>
        <van-cell title="固定资产号" v-model="item.number"></van-cell>
        <van-cell title="SN号" v-model="item.sn"></van-cell>
        <van-cell title="维修原因" v-model="item.reason"></van-cell>
    </div>
</ax-panel>
<ax-panel title="IT工程师检测备注">
    <van-cell title="是否需要借用电脑" v-model="data.is_borrow_pc_name"></van-cell>
</ax-panel>
<ax-panel title="IT工程师维修备注">
    <van-cell title="是否需要报价" v-model="data.is_need_quote_name"></van-cell>
</ax-panel>
<ax-panel title="资产组维修判断">
    <van-cell title="是否需要维修" v-model="data.is_need_repair_name"></van-cell>
</ax-panel>
<ax-panel title="借用设备信息" v-if="data.SUB_itdb_borrow_detail.length">
    <div v-for="(item,index) in data.SUB_itdb_borrow_detail" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="资产类型" v-model="item.type_name"></van-cell>
        <van-cell title="品牌" v-model="item.brand"></van-cell>
        <van-cell title="资产型号" v-model="item.model"></van-cell>
        <van-cell title="固定资产号" v-model="item.number"></van-cell>
        <van-cell title="SN号" v-model="item.sn"></van-cell>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000013580007",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>{{data.pay_type_name}}申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>
<ax-panel title="申请详情">
    <van-cell title="申请单编号" v-model="data.apply_code"></van-cell>
    <van-cell title="员工姓名" v-model="data.employee_name_name"></van-cell>
    <van-cell title="员工编号" v-model="data.employee_no"></van-cell>
    <van-cell title="签订合同主体" v-model="data.contract_main_body"></van-cell>
    <van-cell title="所在部门" v-model="data.employee_dept"></van-cell>
    <ax-fold>
        <van-cell title="付款类型" v-model="data.pay_type_name"></van-cell>
        <van-cell title="员工银行账号" v-model="data.bank_account"></van-cell>
        <van-cell title="员工身份证号" v-model="data.idnumber"></van-cell>
        <van-cell title="支行银行名称" v-model="data.branch_open_bank_name"></van-cell>
        <van-cell title="开户行" v-model="data.open_bank"></van-cell>
        <van-cell title="省" v-model="data.province"></van-cell>
        <van-cell title="市" v-model="data.city"></van-cell>
        <van-cell title="户主名称" v-model="data.householder"></van-cell>
        <van-cell title="申请金额">
            {{data.apply_amount | money}}
        </van-cell>
        <van-cell title="申请说明" v-model="data.explain"></van-cell>
    </ax-fold>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000017040116",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>关怀礼金申请单</em>，请您审批。
            </p>
        </div>
    </ax-head>

<ax-panel title="申请明细">
    <van-cell title="申请类型" v-model="data.apply_type_name"></van-cell>
    <van-cell title="申请金额">
        {{data.apply_money | money}}
    </van-cell>
</ax-panel>
<ax-panel title="家庭抚慰金" v-if="data.apply_type === '4'">
    <van-cell title="亲属关系" v-model="data.c_relationship_name"></van-cell>
    <van-cell title="亲属姓名" v-model="data.c_name"></van-cell>
    <van-cell title="身份证号" v-model="data.c_id_number"></van-cell>
    <van-cell title="辞世日期" v-model="data.c_dead_date"></van-cell>
</ax-panel>
<ax-panel title="康复信息" v-if="data.apply_type === '3'">
    <van-cell title="住院日期" v-model="data.h_start_date"></van-cell>
    <van-cell title="出院日期" v-model="data.h_end_date"></van-cell>
</ax-panel>
<ax-panel title="宝宝信息" v-if="data.apply_type === '2'">
    <van-cell title="宝宝姓名1" v-model="data.b_1_name" v-if="data.b_1_name"></van-cell>
    <van-cell title="宝宝性别" v-model="data.b_1_sex_name" v-if="data.b_1_sex_name"></van-cell>
    <van-cell title="身份证号" v-model="data.b_1_id_number" v-if="data.b_1_id_number"></van-cell>
    <van-cell title="出生日期" v-model="data.b_1_birthday" v-if="data.b_1_birthday"></van-cell>
    <van-cell class="top-item" v-if="data.b_2_name" v-model="data.b_2_name"></van-cell>
    <van-cell title="宝宝性别" v-if="data.b_2_sex_name" v-model="data.b_2_sex_name"></van-cell>
    <van-cell title="身份证号" v-if="data.b_2_id_number" v-model="data.b_2_id_number"></van-cell>
    <van-cell title="出生日期" v-if="data.b_2_birthday" v-model="data.b_2_birthday"></van-cell>
</ax-panel>
<ax-panel title="配偶信息" v-if="data.apply_type === '1'">
    <van-cell title="配偶姓名" v-model="data.m_name"></van-cell>
    <van-cell title="配偶性别" v-model="data.m_sex_name"></van-cell>
    <van-cell title="身份证号" v-model="data.m_id_number"></van-cell>
    <van-cell title="出生日期" v-model="data.m_birthday"></van-cell>
    <van-cell title="手机号码" v-model="data.m_phone"></van-cell>
    <van-cell title="结婚日期" v-model="data.m_wedding_date"></van-cell>
</ax-panel>
<ax-panel title="盖章附件" v-if="isJSON(data.attachment)">
    <ax-down class="out-down" :class="{'top-item':index!==0}" v-for="(fileItem,index) in JSON.parse(data.attachment)" type="ssc" :data="fileItem" :key="index" ></ax-down>
</ax-panel>
<ax-panel title="报销信息">
    <van-cell title="付款单位" v-model="data.pay_unit"></van-cell>
    <van-cell title="付款金额">
        {{data.pay_money | money}}
    </van-cell>
    <van-cell title="收款人" v-model="data.payee"></van-cell>
    <van-cell title="开户银行" v-model="data.open_bank"></van-cell>
    <van-cell title="收款账号" v-model="data.receive_account"></van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000020170258",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>发布备份服务器权限申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>
<ax-panel title="基本信息">
    <van-cell title="业务/项目名称" v-model="data.name"></van-cell>
    <van-cell title="备份服务器IP" v-model="data.backupip_name"></van-cell>
    <van-cell title="服务器默认密码是否已修改" v-model="data.up_default_pwd_name"></van-cell>
    <van-cell title="申请人IP地址" v-model="data.apply_ip"></van-cell>
    <van-cell title="项目性质" v-model="data.project_nature_name"></van-cell>
    <van-cell v-if="data.project_nature!=='1'" title="备份路径" v-model="data.backup_path"></van-cell>
    <van-cell title="发生频率">
        {{data.frequency_input}} / {{data.frequency_item_name}}
    </van-cell>
    <van-cell title="需要空间">
        {{data.space}}MB
    </van-cell>
    <van-cell title="申请目的" v-model="data.aim"></van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000020170072",
        `<ax-head v-if="action">
        <div slot="ing">
            <p>
                来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>内部代码开源申请单</em>，请您审批。
            </p>
        </div>
        
    </ax-head>
<ax-panel title="基本信息">
    <van-cell title="技术领域" v-model="data.technical_field_name"></van-cell>
    <van-cell title="编程语言" v-model="data.programming_language_name"></van-cell>
    <van-cell v-if="data.other_language" title="其他语言" v-model="data.other_language"></van-cell>
    <van-cell title="代码地址" v-model="data.code_address"></van-cell>
    <van-cell title="功能介绍" v-model="data.function_introduction"></van-cell>
    <van-cell title="开源原因" v-model="data.open_reason"></van-cell>
    <ax-fold>
        <van-cell title="技术风险" v-model="data.technical_risks"></van-cell>
        <van-cell title="备注" v-model="data.comment"></van-cell>
    </ax-fold>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000024350007",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>新客户端产品发布申请单</em>，请您审批。
        </p>
    </div>
</ax-head>
<ax-panel title="基本信息">
    <van-cell title="产品名称" v-model="data.name"></van-cell>
    <van-cell title="产品分类" v-model="data.category_name"></van-cell>
    <van-cell title="产品发布渠道" v-model="data.pubcha_name"></van-cell>
    <van-cell title="是否发布过同名产品发到其他平台" v-if="data.pubcha!=1" v-model="data.is_publish_other_name"></van-cell>
    <van-cell title="发布数量或对象" v-model="data.number"></van-cell>
    <van-cell title="产品发布所属实体" v-model="data.company_name"></van-cell>
    <ax-fold>
        <van-cell title="发布日期" v-model="data.date"></van-cell>
        <van-cell title="指定测试人员" v-model="data.test_user_name"></van-cell>
        <van-cell title="产品负责人" v-model="data.product_owner_name"></van-cell>
        <van-cell title="功能说明和技术特点" v-model="data.function"></van-cell>
        <van-cell title="可能存在的问题和风险" v-model="data.risk"></van-cell>
        <div v-if="data.SUB_itdb_newclient_file.length" v-for="(item,index) in data.SUB_itdb_newclient_file" :key="index">
            <van-cell title="涉及文件名称" v-model="item.filename"></van-cell>
            <van-cell title="版本号" v-model="item.version"></van-cell>
            <van-cell title="备注" v-model="item.sub_note"></van-cell>
        </div>
    </ax-fold>
</ax-panel>
<ax-panel title="代码编译签名">
    <van-cell title="代码是否保存在公司统一代码服务器" v-model="data.is_codeincompany_name"></van-cell>
    <van-cell title="代码路径地址" v-model="data.code_path"></van-cell>
    <van-cell title="代码是否包含从外网下载代码的链接" v-model="data.is_includeextranet_link_name"></van-cell>
    <van-cell title="链接地址" v-model="data.link_address"></van-cell>
    <van-cell title="是否使用公司统一的Qbuild编译" v-model="data.is_useqbuild_name"></van-cell>
    <ax-fold>
        <van-cell title="任务名称" v-model="data.taskname"></van-cell>
        <van-cell title="产品签名证书是否由公司提供" v-model="data.is_sign_company_name"></van-cell>
        <van-cell title="证书管理者" v-model="data.certificate_manager"></van-cell>
    </ax-fold>
</ax-panel>
<ax-panel title="法务相关">
    <van-cell title="是否有独立LOGO并与律师确认" v-model="data.is_logo_name"></van-cell>
    <van-cell title="是否具有专利并与律师确认" v-model="data.is_patent_name"></van-cell>
    <van-cell title="是否与其他厂商存在竞争" v-model="data.is_exist_competition_name"></van-cell>
    <van-cell title="是否存在模仿" v-model="data.is_exist_imitate_name"></van-cell>
    <van-cell title="是否有产品外包装" v-model="data.is_outer_pack_name"></van-cell>
    <ax-fold>
        <van-cell title="是否侵犯竞争对手" v-model="data.is_tort_competitor_name"></van-cell>
        <van-cell title="是否侵犯用户权益（知情权、个人隐私等）" v-model="data.is_tort_user_name"></van-cell>
        <van-cell title="是否侵犯其他知识产权(抄袭、模仿等)" v-model="data.is_tort_knowledge_name"></van-cell>
        <van-cell title="是否有软件著作权登记" v-model="data.is_copyright_name"></van-cell>
        <van-cell title="广告宣传语" v-model="data.advertising"></van-cell>
        <van-cell title="硬件产品生产/销售资质申请情况" v-model="data.product_qualification"></van-cell>
        <van-cell title="产品软件许可使用协议、硬件产品使用说明书、注意事项及保修政策" v-model="data.needing_attention"></van-cell>
        <van-cell title="关联用户协议申请" v-model="data.user_protocol_name"></van-cell>
        <van-cell title="补充说明" v-model="data.supplementary_notes"></van-cell>
        <van-cell title="法务相关附件" v-if="isJSON(data.legal_attachment)">
            <ax-down v-for="(fileItem,index) in JSON.parse(data.legal_attachment)" type="ssc" :data="fileItem" :key="index" ></ax-down>
        </van-cell>
        
    </ax-fold>
</ax-panel>
<ax-panel title="安全相关">
    <van-cell title="说明" class="des-cell">
        移动端安卓+IOS+web服务器端入口：http：//sec.corp.qihoo.net/ &nbsp; <br/>PC端审核入口：http://vulneye.hips.corp.qihoo.net/projects/ssstest
    </van-cell>
    
    <van-cell title="PC/Linux安全审计编号" desc="类型为pc/linux展示"  v-if="data.category<4" v-model="data.pclinux_audit_number"></van-cell>
    <template v-else>
        <van-cell title="移动安全审核编号" desc="类型为移动端展示"   v-model="data.mobile_audit_number"></van-cell>
        <van-cell title="WEB端安全审计编号" v-model="data.web_audit_number"></van-cell>
    </template>
    <van-cell title="安全相关附件" v-if="isJSON(data.security_attachment)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.security_attachment)" type="ssc" :data="fileItem" :key="index" ></ax-down>
    </van-cell>
</ax-panel>

<ax-panel title="隐私相关" v-if="data.pubcha!=1" desc="内部产品时不展示">
    <van-cell title="对于打点" v-model="data.privacy_dot"></van-cell>
    <van-cell title="对于功能兼打点" v-model="data.privacy_fu_dot"></van-cell>
    <van-cell title="对于产品功能" v-model="data.privacy_function"></van-cell>
    <van-cell title="隐私相关附件" v-if="isJSON(data.privacy_attachment)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.privacy_attachment)" type="ssc" :data="fileItem" :key="index" ></ax-down>
    </van-cell>
    
</ax-panel>
<ax-panel title="运营试用培训"  v-if="data.pubcha!=1" desc="内部产品时不展示">
    <van-cell class="des-cell" title="说明">
        新产品以及新功能发布前，需要提前给运营部门的同事试用；如有必要，部分产品还需要产品给运营相关同事进行现场培训发送邮件组：g-ps-run@360.cn;抄送g-360-shenpi@360.cn
    </van-cell>
</ax-panel>
<ax-panel title="搜索部门相关" v-if="data.pubcha!=1" desc="内部产品时不展示">
    <van-cell title="是否有官网" v-model="data.is_website_name"></van-cell>
    <van-cell title="官网地址" v-model="data.website_address"></van-cell>
    <van-cell title="产品说明" v-model="data.search_pr_relevance"></van-cell>
</ax-panel>
<ax-panel title="新产品下载域名确认" >
    <van-cell title="说明" class="des-cell">
        新产品的官网下载域名,统一使用http://down.360safe.com/xxx/xxx.apk
 1.目录及下载url是否重名
 2.域名后面，必须加一级目录
 3.Down.360safe.cn 此域名下载，只用于官网http下载：若要主动给用户升级，请使用dll.360safe.com
    </van-cell>
    <van-cell title="新产品下载域名" v-model="data.download_domain"></van-cell>
</ax-panel>
<ax-panel title="其他相关"  v-if="data.category > 3">
    <van-cell title="bundle ID"  v-if="data.bundle_id" v-model="data.bundle_id"></van-cell>
    <van-cell title="应用包名" v-if="data.app_packagename"  v-model="data.app_packagename"></van-cell>
    <van-cell title="应用签名" v-if="data.app_sign" v-model="data.app_sign"></van-cell>
    <van-cell title="APP文件上传" v-if="isJSON(data.app_attachment)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.app_attachment)" type="ssc" :data="fileItem" :key="index" ></ax-down>
    </van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_2490000001341029",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>IoT商品领用申请单</em>，请您审批。
        </p>
    </div>
</ax-head>
<ax-panel title="申请说明">
    <van-cell class="des-cell">
        1，单笔领用单费用大于2W需填写预算编号；每一份申请单只关联一个预算单号<br/>
        2，Mark 黄色底色的内容有申请人填写完整，确保信息正确；<br/>
        3，领用单价参考商城零售价格；<br/>
        4，申请必须优先通过产品归属部门GTM确认产品可领用；<br/>
        5，然后通过产品归属部门业务线负责人确认可领用；<br/>
        6，物流安排发货后通知申请人
    </van-cell>
</ax-panel>
<ax-panel title="基础信息">
    <van-cell title="申请编号" v-model="data.apply_code"></van-cell>
    <van-cell title="产品线" v-model="data.product_line_name"></van-cell>
    <van-cell title="费用归属部门" v-model="data.cost_dept_name"></van-cell>
</ax-panel>
<ax-panel title="产品信息" v-if="data.SUB_iot_commodity_product_lines.length">
    <div v-for="(item, index) in data.SUB_iot_commodity_product_lines" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="产品描述/产品型号" v-model="item.product_desc_name"></van-cell>
        <van-cell title="商品数量(台)" v-model="item.product_number"></van-cell>
        <van-cell title="单价-商城零售价(元/人民币)" v-model="item.product_price"></van-cell>
        <van-cell title="金额小计(元/人民币)" v-model="item.product_amount"></van-cell>
    </div>
    <van-cell class="top-item" title="总计(小写)" v-model="data.product_total_amount"></van-cell>
    <van-cell title="总计(大写)" v-model="data.product_total_amount_capital"></van-cell>
</ax-panel>
<ax-panel title="预算信息" v-if="data.SUB_iot_commodity_budget_lines.length">
    <div v-for="(item, index) in data.SUB_iot_commodity_budget_lines" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="预算项目名称" :value="item.budget_name_name"></van-cell>
        <van-cell title="项目预算编码">{{item.budget_code}}</van-cell>
        <van-cell title="预算来源">{{item.budget_source}}</van-cell>
        <van-cell title="预算使用情况">
            <router-link class="link_a" :to="'/ssc/budget/details?id='+item.budget_code">查看</router-link>
        </van-cell>
        <ax-fold>
            <van-cell title="预算剩余金额">{{item.budget_residual_amount}}</van-cell>
            <van-cell title="预算使用金额">{{item.budget_occupancy_amount}}</van-cell>
        </ax-fold>
    </div>
</ax-panel>
<ax-panel title="收货信息" v-if="data.SUB_iot_commodity_receive_lines.length">
    <div v-for="(item, index) in data.SUB_iot_commodity_receive_lines" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="收货人姓名" v-model="item.contact_name"></van-cell>
        <van-cell title="联系电话" v-model="item.contact_phone"></van-cell>
        <van-cell title="省" v-model="item.contact_province_name"></van-cell>
        <van-cell title="市" v-model="item.contact_city_name"></van-cell>
        <ax-fold>
            <van-cell title="区" v-model="item.contact_area_name"></van-cell>
            <van-cell title="详细地址" v-model="item.contact_address"></van-cell>
            <van-cell title="产品" v-model="item.product_desc_name"></van-cell>
            <van-cell title="数量" v-model="item.product_number"></van-cell>
            <van-cell title="用途" v-model="item.product_use_name"></van-cell>
        </ax-fold>
    </div>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000027600030",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>资产报废申请单</em>，请您审批。
        </p>
    </div>
</ax-head>
<ax-panel title="报废信息">
    <van-cell title="申请编号" v-model="data.apply_code"></van-cell>
    <van-cell title="报废类型" v-model="data.retirement_type_name"></van-cell>
    <van-cell title="设备类别" v-model="data.device_catetgory_name"></van-cell>
    <van-cell title="报废原因" v-if="data.retirement_cause" v-model="data.retirement_cause"></van-cell>
    <van-cell title="报废总数">{{data.retirement_quantity}}台</van-cell>
    <ax-fold>
        <van-cell title="数量说明" v-if="data.quantity_explain" v-model="data.quantity_explain"></van-cell>
        <van-cell title="采购总价">
            {{data.purchase_amount}}元
        </van-cell>
        <van-cell title="价格说明" v-if="data.amount_explain" v-model="data.amount_explain"></van-cell>
        <van-cell title="报废清单" v-if="isJSON(data.retirement_list)">
            <ax-down v-for="(fileItem,index) in JSON.parse(data.retirement_list)" type="ssc" :data="fileItem" :key="index" ></ax-down>
        </van-cell>
        <van-cell title="报废备注" v-model="data.retirement_remark"></van-cell>
    </ax-fold>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000025810347",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>硬件RMA报废申请单</em>，请您审批。
        </p>
    </div>
</ax-head>
<ax-panel title="基础信息">
    <van-cell title="申请编号" v-model="data.number"></van-cell>
    <van-cell title="报废单位" v-model="data.unit_retired_name"></van-cell>
    <van-cell title="工厂" v-model="data.factory_name"></van-cell>
    <van-cell title="产品业务业务线" v-model="data.product_line_name"></van-cell>
    <van-cell title="报废原因及备注" v-model="data.notes"></van-cell>
</ax-panel>
<ax-panel title="详细信息" v-if="data.SUB_itdb_rma_detail.length">
    <div v-for="(item, index) in data.SUB_itdb_rma_detail" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="物料id" v-model="item.product_id"></van-cell>
        <van-cell title="物料名称" v-model="item.product_name"></van-cell>
        <van-cell title="加权平均单价" v-model="item.product_price"></van-cell>
        <van-cell title="数量" v-model="item.product_count"></van-cell>
        <van-cell title="金额">
            {{item.product_amount|money}}
        </van-cell>
    </div>
    <van-cell class="top-item" title="总计">
        {{data.product_total_amount|money}}
    </van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000028820195",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>企业安全备案申请单</em>，请您审批。
        </p>
    </div>
</ax-head>
<ax-panel title="申请详情">
    <van-cell title="单据编号" v-model="data.code"></van-cell>
    <van-cell title="交流类型" v-model="data.commun_type_name"></van-cell>
    <van-cell title="事项名称" v-model="data.item_name"></van-cell>
    <van-cell title="申请时间" v-model="data.apply_date"></van-cell>
    <van-cell title="活动主题" v-model="data.activity_theme"></van-cell>
    <ax-fold>
        <van-cell title="主办方" v-model="data.sponsor"></van-cell>
        <van-cell title="交流地点" v-model="data.commun_place"></van-cell>
        <van-cell title="交流开始时间" v-model="data.commun_start_date"></van-cell>
        <van-cell title="活动规模" v-model="data.activity_scale"></van-cell>
        <van-cell title="涉及人员" v-model="data.involve_person"></van-cell>
        <van-cell title="活动概述" v-model="data.activity_overview"></van-cell>
    </ax-fold>
</ax-panel>
<ax-panel title="发起人回填" v-if="bpmTask.name !== '部门领导(M级)'&&bpmTask.name !== '媒介/公关组'&&bpmTask.name !== '发起人(回填业务)'">
    <van-cell title="业务选项" v-model="data.involved_dept_name"></van-cell>
    <van-cell title="演讲稿" v-if="isJSON(data.speech_draft)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.speech_draft)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
</ax-panel>
<ax-panel title="轮值班长回填" v-if="bpmTask.name === 'CEO'&&data.is_ceo_approval">
    <van-cell title="是否CEO审批" v-model="data.is_ceo_approval_name"></van-cell>
</ax-panel>
<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}}</a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    [
        "MFM_1100000029261543",
        `<ax-head v-if="action">
<div slot="ing">
    <p>
        来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>电子公章申请单</em>，请您审批。
    </p>
</div>
</ax-head>
<ax-panel title="申请详情">
    <van-cell class="top-item" title="公章所属公司" v-model="data.company_name"></van-cell>
    <van-cell title="是否已经通过其他系统审批" v-model="data.is_otapprove_name"></van-cell>
    <van-cell title="上传其他系统审批单" v-if="isJSON(data.ot_bill)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.ot_bill)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
    <van-cell title="使用目的" v-model="data.use_purpose"></van-cell>
    <van-cell title="需盖章文件" v-if="isJSON(data.need_seal)">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.need_seal)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
    <final-signfile ref="finalSignFile" v-if="bpmTask.name === '法务公章及资质执行组' && formKey === 'MFM_1100000029261543'" :file="data.final_sign_file" :contractId="data.contractId" />
</ax-panel>

<ax-panel title="法务回填信息" v-if="permission.approve_choose_form==='w'">
    <van-cell title="法务回填" :class="{ 'errors_box':errors.has('approveChoose')}">
      <van-checkbox-group v-model="modelData.approve_choose" v-validate="{ required: !modelData.none_approve }" name="approveChoose" :disabled="modelData.none_approve">
        <van-checkbox
          v-for="item in backfillValues"
          :key="item.value"
          :name="item.value"
        >
          {{ item.label }}
        </van-checkbox>
      </van-checkbox-group>
      <van-checkbox v-model="modelData.none_approve" @change="val => val && (modelData.approve_choose = [])">无需特殊审批</van-checkbox>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}}</a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
    // 机房门禁
    [
        "MFM_1100000000750311",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>机房门禁权限申请单</em>，请您审批。
        </p>
    </div>
    </ax-head>
    <ax-panel title="申请信息">
    <van-cell title="对应机房门" v-model="data.cpt_room_door_name"></van-cell>
    <van-cell title="房间" v-model="data.room_name"></van-cell>
    <van-cell title="申请原因" v-model="data.reason"></van-cell>
    <van-cell title="申请编号" v-model="data.number"></van-cell>
    </ax-panel>
    <ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="&#39;mailto:&#39;+startUser.userNo+&#39;@360.cn&#39;">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="&#39;tel:&#39;+startUser.mobile">{{startUser.mobile}}</a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
  </ax-panel>`
    ],
    // 手机彩打申请
    [
        "MFM_1100000000840002",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>彩打申请单</em>，请您审批。
        </p>
    </div>
    </ax-head>
    <ax-panel title="相关信息">
    <van-cell title="申请原因" v-model="data.apply_reason"></van-cell>
    </ax-panel>
    <ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="&#39;mailto:&#39;+startUser.userNo+&#39;@360.cn&#39;">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="&#39;tel:&#39;+startUser.mobile">{{startUser.mobile}}</a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
  </ax-panel>`
    ],
    // 通用开票申请表
    [
        "MFM_1300000000230694",
        `<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>通用开票申请单</em>，请您审批。
        </p>
    </div>
    </ax-head>
    <ax-panel title="申请详情">
    <van-cell title="来源系统" v-model="data.source_system_name"></van-cell>
    <van-cell title="来源系统编号" v-model="data.source_system_code"></van-cell>
    <van-cell title="业务类型" v-model="data.bussiness_type_name"></van-cell>
    <van-cell title="开票申请编号" v-model="data.invoice_code"></van-cell>
    <van-cell title="发票类型" v-model="data.invoice_type_name"></van-cell>
    <van-cell title="是否有合同" v-model="data.is_contract_name"></van-cell>
    </ax-panel>
    <ax-panel title="合同信息" v-show="data.is_contract_name === '是'">
    <van-cell title="关联合同">
        <router-link class="link_a" v-if="!data.contract_source_system || data.contract_source_system=='SSC'" :to="'/ssc/complete/details?instId='+data.contract_instid">
            {{data.contract_name}}
        </router-link>
        <a v-else  class="link_a"  target="blank" :href="$contract_baseurl+ '/ccrt/search/list?contractNumber='+ data.contract_code"> {{data.contract_name}}</a>   
    </van-cell>
    <van-cell title="合同名称" v-model="data.contract_name"></van-cell>
    <van-cell title="旧OA合同编号" v-model="data.old_oa_contract_code"></van-cell>
    <van-cell title="合同金额">
        {{data.contract_amount | money}}
    </van-cell>
    <van-cell title="合同摘要" v-model="data.contract_digest"></van-cell>
    <ax-panel title="附件" v-if="isJSON(data.stamp_file)">
     <ax-down class="out-down" v-for="(fileItem,index) in JSON.parse(data.stamp_file)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </ax-panel>
    </ax-panel>
    <ax-panel title="开票信息">
    <van-cell title="合同我方主体" v-model="data.contract_company"></van-cell>
    <van-cell title="合同对方主体" v-model="data.contract_customer"></van-cell>
    <van-cell title="我方主体" v-model="data.our_company_name"></van-cell>
    <van-cell title="纳税人识别号-我方主体" v-model="data.our_tax_num"></van-cell>
    <van-cell title="购买方名称（发票抬头）" v-model="data.customer_name"></van-cell>
    <van-cell title="购买方税号" v-model="data.customer_tax_num"></van-cell>
    <van-cell title="购买方开户银行名称" v-model="data.open_bank_name"></van-cell>
    <van-cell title="购买方银行账号" v-model="data.open_bank_accounts"></van-cell>
    <van-cell title="购买方地址" v-model="data.cus_contact_address"></van-cell>
    <van-cell title="购买方电话" v-model="data.cus_contact_phone"></van-cell>
    </ax-panel>
    <ax-panel title="发票明细">
        <div v-for="(item, index) in data.SUB_inv_order_lines" :key="index">
            <van-cell :class="{'top-item':index!==0}" title="商品分类" v-model="item.category"></van-cell>
            <van-cell title="商品名称" v-model="item.product_name_name"></van-cell>
            <van-cell title="单价">
                {{item.price|money}}
            </van-cell>
            <van-cell title="数量">
                {{item.quantity|money}}
            </van-cell>
            <van-cell title="金额(含税价)">
            {{item.tax_amount|money}}
            </van-cell>
        <ax-fold> 
            <van-cell title="折扣总金额" v-model="item.discount_amount">
            {{item.discount_amount|money}}
            </van-cell>
            <van-cell title="税率(%)">
            {{item.tax_rate|money}}
            </van-cell>
            <van-cell title="规格" v-model="item.specification"></van-cell>
        </ax-fold>
        </div>
    <van-cell class="top-item" title="开票金额合计(含税价)">
        {{data.amount|money}}
    </van-cell>
    </ax-panel>
    <ax-panel title="收款信息">
    <van-cell title="收款来源" v-model="data.receipt_source_name"></van-cell>
    <van-cell title="支付中心-商户号" v-model="data.pay_merchant_no"></van-cell>
    <van-cell title="支付中心-交易订单号" v-model="data.pay_trade_no"></van-cell>
    <van-cell title="可开票金额">
        {{data.invoiced_amount | money}}
        （已开票金额:{{data.exist_invoice_amount | money}}）
    </van-cell>
    </ax-panel>
    <ax-panel title="收件信息">
    <van-cell title="收件人" v-model="data.addressee"></van-cell>
    <van-cell title="收件人联系电话" v-model="data.addressee_phone"></van-cell>
    <van-cell title="邮寄地址" v-model="data.post_address"></van-cell>
    </ax-panel>
    <ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="&#39;mailto:&#39;+startUser.userNo+&#39;@360.cn&#39;">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="&#39;tel:&#39;+startUser.mobile">{{startUser.mobile}}</a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
  </ax-panel>`
    ],
    // 人力成本分摊结算
    [
        "MFM_7380000000200010",
        `<ax-head v-if="action">
    <div slot="ing">
      <p>
        来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>人力成本分摊结算</em>，请您审批。
      </p>
    </div>
    </ax-head>
    <ax-panel title="申请详情">
    <van-cell title="结算单号" v-model="data.code"></van-cell>
    <van-cell title="业务部门(一级)" v-model="data.business_dept_name"></van-cell>
    <van-cell title="结算年月" v-model="data.settlement_month"></van-cell>
    <van-cell title="部门接口人" v-model="data.contact_user_name"></van-cell>
    <van-cell title="结算总金额(不含税)">
      {{data.totalfee | money}}元
    </van-cell>
    <van-cell title="合同编号" v-model="data.contract_code"></van-cell>
    <van-cell title="税率" v-model="data.taxrate_name"></van-cell>
    <van-cell title="结算说明" v-model="data.apply_desc"></van-cell>
    </ax-panel>
    <ax-panel title="发票明细">
      <div v-for="(item, index) in data.SUB_itdb_cost_settlement_detail" :key="index">
        <van-cell :class="{'top-item':index!==0}" title="流程单号" v-model="item.bill_no"></van-cell>
        <van-cell title="入账年份" v-model="item.year"></van-cell>
        <van-cell title="入账月份" v-model="item.month"></van-cell>
        <van-cell title="费用部门" v-model="item.fee_dept"></van-cell>
        <van-cell title="资源部门" v-model="item.res_dept"></van-cell>
        <van-cell title="员工类型" v-model="item.emp_type"></van-cell>
        <van-cell title="职能" v-model="item.func"></van-cell>
        <van-cell title="级别" v-model="item.level"></van-cell>
        <van-cell title="计费方式" v-model="item.billing_mode"></van-cell>
        <van-cell title="费用合计">
          {{item.fee | money }}
        </van-cell>
        <van-cell title="申请类型" v-model="item.apply_type_name"></van-cell>
        <van-cell title="是否纳入管报" v-model="item.is_manage"></van-cell>
      </div>
    </ax-panel>
    <ax-panel title="申请人信息">
    <van-cell title="姓名" :value="startUser.fullname"></van-cell>
    <van-cell title="域账号">
      <a class="mail_a" :href="&#39;mailto:&#39;+startUser.userNo+&#39;@360.cn&#39;">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
      <a class="link_a" :href="&#39;tel:&#39;+startUser.mobile">{{startUser.mobile}}</a>
    </van-cell>
    <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
    </ax-panel>`
    ],
    // 费用预提申请
    [
        "MFM_2430000017855852",
        `<ax-head v-if="action">
    <div slot="ing">
      <p>
        来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>费用预提申请</em>，请您审批。
      </p>
    </div>
    </ax-head>
    <ax-panel title="费用预提申请">
      <van-cell title="预提申请编号" v-model="data.code"></van-cell>
      <van-cell title="期间" v-model="data.period_name"></van-cell>
      <van-cell title="币种名称" v-model="data.currency_name"></van-cell>
      <van-cell title="预提总金额" v-model="data.amount"></van-cell>
      <van-cell title="预提总金额（人民币）" v-model="data.base_amount"></van-cell>
      <ax-panel title="附件" v-if="isJSON(data.attachment)">
        <ax-down class="out-down" v-for="(fileItem,index) in JSON.parse(data.attachment)" type="ssc" :data="fileItem" :key="index"></ax-down>
      </ax-panel>
      <van-cell title="申请概述" v-model="data.apply_desc"></van-cell>
    </ax-panel>
    <ax-panel title="预提费用行" v-if="data.SUB_ap_accrued_lines.length && data.SUB_ap_accrued_lines.length > 0">
      <div v-for="(item, index) in data.SUB_ap_accrued_lines" :key="index" style="border-bottom:1px solid rgba(0, 0, 0, 0.1)">
        <van-cell title="预提编号" v-model="item.code"></van-cell>
        <van-cell title="关联合同" v-model="item.contract_name"></van-cell>
        <van-cell title="预算编号" v-model="item.budget_code"></van-cell>
        <van-cell title="预算金额" v-model="item.budget_amount"></van-cell>
        <van-cell title="预算名称" v-model="item.budget_name"></van-cell>
        <van-cell title="付款主体" v-model="item.pay_company_name"></van-cell>
        <van-cell title="供应商" v-model="item.vendor"></van-cell>
        <van-cell title="费用归属部门" v-model="item.expense_department_name"></van-cell>
        <van-cell title="费用类型" v-model="item.expense_type_name"></van-cell>
        <van-cell title="预提金额" v-model="item.accrued_amount"></van-cell>
        <van-cell title="项目类型" v-model="item.project_type_name"></van-cell>
        <ax-panel title="附件" v-if="isJSON(item.attachment)">
          <ax-down class="out-down" v-for="(fileItem,index) in JSON.parse(item.attachment)" type="ssc" :data="fileItem" :key="index"></ax-down>
        </ax-panel>
        <van-cell title="备注" v-model="item.note"></van-cell>
        <van-cell title="项目编号" v-model="item.project_number"></van-cell>
        <van-cell title="项目名称" v-model="item.buiness_project_name"></van-cell>
      </div>
    </ax-panel>`
    ],
    // iot立项申请单子
    [
        "MFM_2410000005270518",
        `
    <div class="MFM_2410000005270518">
        <ax-head v-if="action">
            <div slot="ing">
                <p>
                    来自{{ startUser.depPathNames }}
                    <em>{{ startUser.fullname }}</em>的
                    <em>IOT立项申请单</em>，请您审批。
                </p>
            </div>
        </ax-head>
        <ax-panel title="智能硬件项目立项申请">
            <van-cell title="业务项目编码" v-if="data.code" v-model="data.code"></van-cell>
            <van-cell title="项目编码" v-if="data.number" v-model="data.number"></van-cell>
            <van-cell title="项目名称" v-model="data.name"></van-cell>
            <van-cell title="产品线" v-model="data.product_line_name"></van-cell>
            <van-cell title="项目性质" v-model="data.nature_name"></van-cell>
            <van-cell title="项目目标" v-model="data.goal"></van-cell>
            <van-cell title="项目预算(万)" v-model="data.budget"></van-cell>
            <van-cell title="项目总费用" v-if="currentType == 'approvalPending'">
                <van-field type="number" style="display: inline-block;padding: 0;background-color: #f5f7fa !important;" v-model="data.totalfee" placeholder="请输入项目总费用" />
                <div style="font-size: 12px;color: #f7a75b;">{{ iotApplicationForm.hint }}</div>
            </van-cell>
            <van-cell v-else title="项目总费用" v-model="data.totalfee">
            </van-cell>
            <van-cell title="合作方选择" v-model="data.partner_choice"></van-cell>
            <van-cell title="立项申请书" v-if="isJSON(data.pt_approval)">
                <ax-down v-for="(fileItem,index) in JSON.parse(data.pt_approval)" type="ssc" :data="fileItem" :key="index"></ax-down>
            </van-cell>
        </ax-panel>

        <ax-panel title="关键里程碑时间">
            <van-cell title="立项开始时间" v-model="data.item_date"></van-cell>
            <van-cell title="模拟开始时间" v-model="data.open_mold"></van-cell>
            <van-cell title="量产时间" v-model="data.batch_production"></van-cell>
            <van-cell title="试产时间" v-model="data.trial_production"></van-cell>
            <van-cell title="上市时间" v-model="data.into_market"></van-cell>
            <van-cell title="推出时间" v-model="data.exit"></van-cell>
        </ax-panel>

        <ax-panel title="销售预测">
            <van-cell title="预计月销量(PCs)" v-model="data.month_sales"></van-cell>
            <van-cell title="预计总销量(PCs)" v-model="data.total_sales"></van-cell>
            <van-cell title="IOT总收入金额(元)" v-model="data.total_income"></van-cell>
        </ax-panel>

        <ax-panel title="执行策略">
            <van-cell title="产量成本预测" v-model="data.data_ten_ce"></van-cell>
            <van-cell title="附件" v-if="isJSON(data.data_ten_attachment)">
                <ax-down v-for="(fileItem,index) in JSON.parse(data.data_ten_attachment)" type="ssc" :data="fileItem" :key="index"></ax-down>
            </van-cell>
        </ax-panel>

        <ax-panel title="产品定价销售策略及损益">
            <van-cell title="平均出货单价（不含税，元）" v-model="data.data_eleven_sp"></van-cell>
            <van-cell title="单台成本（不含税，元）" v-model="data.data_eleven_cp"></van-cell>
            <van-cell title="预计总销量(PCs)" v-model="data.data_eleven_pts"></van-cell>
            <van-cell title="预计毛收入（不含税，万元）" v-model="data.gross_income_notax"></van-cell>
            <van-cell title="预计净损益/净利润（不含税，万元）" v-model="data.net_profit_notax"></van-cell>
            <van-cell title="附件" v-model="data.data_eleven_attachment">
                <ax-down v-for="(fileItem,index) in JSON.parse(data.data_eleven_attachment)" type="ssc" :data="fileItem" :key="index"></ax-down>
            </van-cell>
        </ax-panel>

        <ax-panel title="申请人信息">
            <van-cell title="姓名" :value="startUser.fullname"></van-cell>
            <van-cell title="域账号">
                <a class="mail_a" :href="&#39;mailto:&#39;+startUser.userNo+&#39;@360.cn&#39;">{{ startUser.userNo }}</a>
            </van-cell>
            <van-cell title="电话">
                <a class="link_a" :href="&#39;tel:&#39;+startUser.mobile">
                    {{
          startUser.mobile
          }}
                </a>
            </van-cell>
            <van-cell title="部门" :value="startUser.depPathNames"></van-cell>
        </ax-panel>
    </div>
    `
    ],
    [
        // 财务资金类资质/文件申请单（参照 MFM_4760000020242478 的模板结构）
        "MFM_1100000039016543",
        `
<ax-head v-if="action">
    <div slot="ing">
        <p>
            来自{{startUser.depPathNames}}<em>{{startUser.fullname}}</em>的<em>财务资金类资质/文件申请单</em>，请您审批。
        </p>
    </div>
</ax-head>

<ax-panel title="申请信息">
    <van-cell title="申请类型">{{data.fin_apply_type_name}}</van-cell>
    <van-cell title="是否用印" v-model="data.is_use_seal_name"></van-cell>
    <van-cell title="用印类型" v-model="data.seal_category_name"></van-cell>
    <van-cell title="使用目的" v-model="data.fin_purpose"></van-cell>
    <van-cell title="我方主体名称" v-model="data.company_name"></van-cell>
    <div class="">
        <div class="paddingl" style="font-size: 14px;line-height: 2;">对方主体:</div>
        <template v-for="(item, index) in data.SUB_financial_opposite_subject ">
            <van-cell :class="{'top-item':index!==0}" title="对方主体名称" v-model="item.oppsite_name"></van-cell>
            <van-cell title="风险主体" v-model="item.risk_company"></van-cell>
            <van-cell title="关联交易对象评估申请单" v-model="item.black_form_name"></van-cell>
        </template>
    </div>
</ax-panel>

<ax-panel title="资金类 - 账户信息 / 开户许可证" v-if="hasType(data.fin_apply_type, 'zhxx')">
    <van-cell title="账户类型" v-model="data.fin_acc_type_name"></van-cell>
    <van-cell title="是否需要开户许可证/基本存款账户信息" v-model="data.fin_acc_cert_name" v-if="data.fin_acc_type === '基本户'"></van-cell>
    <van-cell title="币种" v-model="data.fin_acc_ccy" v-if="data.fin_acc_ccy"></van-cell>
</ax-panel>

<ax-panel title="资金类 - 资信证明" v-if="hasType(data.fin_apply_type, 'zxzm')">
    <van-cell title="资信证明用途" v-model="data.fin_cr_use"></van-cell>
    <van-cell title="电子版/纸质版" v-model="data.fin_cr_media_name"></van-cell>
    <van-cell title="所需份数" v-model="data.fin_cr_count"></van-cell>
    <van-cell title="证明内容" v-model="data.fin_cr_content_name"></van-cell>
    <template v-if="hasType(data.fin_cr_content, '存款余额证明')">
        <van-cell title="存款余额证明时间节点" v-model="data.fin_cr_b_date"></van-cell>
        <van-cell title="余额要求" v-model="data.fin_cr_b_req" v-if="data.fin_cr_b_req"></van-cell>
    </template>
    <template v-if="hasType(data.fin_cr_content, '结算记录证明')">
        <van-cell title="结算记录时间段" v-if="data.fin_cr_s_from || data.fin_cr_s_to">
            {{data.fin_cr_s_from}}<span v-if="data.fin_cr_s_from && data.fin_cr_s_to"> 至 </span>{{data.fin_cr_s_to}}
        </van-cell>
    </template>
</ax-panel>

<ax-panel title="资金类 - 回单" v-if="hasType(data.fin_apply_type, 'hd')">
    <van-cell title="回单数量" v-model="data.fin_rc_kind_name"></van-cell>
    <van-cell title="回单信息附件" v-if="isJSON(data.fin_rc_batch_file)" v-show="data.fin_rc_kind === '批量'">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.fin_rc_batch_file)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
    <template v-if="data.fin_rc_kind === '单笔'">
        <van-cell title="银行流水号">{{data.fin_rc_ser || '—'}}</van-cell>
        <van-cell title="收款单位名称">{{data.fin_rc_payee_name || '—'}}</van-cell>
        <van-cell title="收款银行">{{data.fin_rc_payee_bank || '—'}}</van-cell>
        <van-cell title="收款账号">{{data.fin_rc_payee_acc || '—'}}</van-cell>
        <van-cell title="币种">{{data.fin_rc_ccy || '—'}}</van-cell>
        <van-cell title="付款单位名称">{{data.fin_rc_payer_name || '—'}}</van-cell>
        <van-cell title="付款账号">{{data.fin_rc_payer_acc || '—'}}</van-cell>
        <van-cell title="付款银行">{{data.fin_rc_payer_bank || '—'}}</van-cell>
        <van-cell title="金额">{{data.fin_rc_amt || '—'}}</van-cell>
    </template>
</ax-panel>

<ax-panel title="资金类 - 银行对账单" v-if="hasType(data.fin_apply_type, 'yhdzd')">
    <van-cell title="所需账户" v-model="data.fin_st_acc_name"></van-cell>
    <van-cell title="对账单时间段" v-if="data.fin_st_from && data.fin_st_to">{{data.fin_st_from}} 至 {{data.fin_st_to}}</van-cell>
    <van-cell title="账户要求" v-model="data.fin_st_req" v-if="data.fin_st_req"></van-cell>
</ax-panel>

<ax-panel title="资金类 - 银行流水" v-if="hasType(data.fin_apply_type, 'yhls')">
    <van-cell title="所需账户" v-model="data.fin_fl_acc_name"></van-cell>
    <van-cell title="指定账户号" v-model="data.fin_fl_accno" v-if="data.fin_fl_acc === '指定账户' && data.fin_fl_accno"></van-cell>
    <van-cell title="银行流水时间段" v-if="data.fin_fl_from && data.fin_fl_to">{{data.fin_fl_from}} 至 {{data.fin_fl_to}}</van-cell>
    <van-cell title="账户要求" v-model="data.fin_fl_req" v-if="data.fin_fl_req"></van-cell>
</ax-panel>

<ax-panel title="资金类 - 账户余额信息" v-if="hasType(data.fin_apply_type, 'zhye')">
    <van-cell title="所需账户" v-model="data.fin_bl_acc_name"></van-cell>
    <van-cell title="余额时间点" v-model="data.fin_bl_date"></van-cell>
    <van-cell title="账户要求" v-model="data.fin_bl_req" v-if="data.fin_bl_req"></van-cell>
</ax-panel>

<ax-panel title="资金类 - 收据" v-if="hasType(data.fin_apply_type, 'sk')">
    <van-cell title="收款事由" v-model="data.fin_iv_reason"></van-cell>
    <van-cell title="是否已收款" v-model="data.fin_iv_paid_name"></van-cell>
    <template v-if="data.fin_iv_paid === '是'">
        <van-cell title="银行流水号" v-model="data.fin_iv_ser"></van-cell>
        <van-cell title="收款账户" v-model="data.fin_iv_acc"></van-cell>
        <van-cell title="收款日期" v-model="data.fin_iv_date"></van-cell>
        <van-cell title="收款金额" v-model="data.fin_iv_amt"></van-cell>
    </template>
</ax-panel>

<ax-panel title="备注" v-if="data.remarks">
    <van-cell title="备注" v-model="data.remarks"></van-cell>
</ax-panel>

<ax-panel title="承诺条款">
    <van-cell>
        <div>申请人承诺：</div>
        <div>1、本次申请获取的资料信息，仅用于申请载明的实际业务用途，不存在超业务范围、超授权权限申请的情况。</div>
        <div>2、本人对所获取的全部资料信息履行保密义务，严格控制知悉范围；仅限本次申请载明的业务使用，不挪作其他任何用途，不擅自复制、转发、对外提供。业务办结后，及时对纸质、电子副本予以销毁/删除，不私自留存任何备份。</div>
        <div>3、本人将严格遵守《360集团数据安全管理制度》等制度要求，自愿接受公司相关部门及人员的监督与管理。</div>
        <div>以上承诺，如有违规情形，本人愿意承担相应责任与处罚。</div>
    </van-cell>
</ax-panel>

<ax-panel title="附件" v-if="isJSON(data.attachment)">
    <van-cell title="附件">
        <ax-down v-for="(fileItem,index) in JSON.parse(data.attachment)" type="ssc" :data="fileItem" :key="index"></ax-down>
    </van-cell>
</ax-panel>

<ax-panel title="申请人信息">
    <van-cell title="姓名" v-model="startUser.fullname"></van-cell>
    <van-cell title="域账号">
        <a class="mail_a" :href="'mailto:'+startUser.userNo+'@360.cn'">{{startUser.userNo}}</a>
    </van-cell>
    <van-cell title="电话">
        <a class="link_a" :href="'tel:'+startUser.mobile">{{startUser.mobile}} </a>
    </van-cell>
    <van-cell title="部门" v-model="startUser.depPathNames"></van-cell>
</ax-panel>`
    ],
]);

export { formMap };

